export const commoditiesSpecialtiesMock = {
  "type": "Commodities",
  "title": "Commodities & Specialties",
  "subMenu": null,
  "navigation": {
    "nav": [
      {
        "data": {
          "qtd": [
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          361,
                          494
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          425,
                          437
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          564,
                          566
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          601,
                          795
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          289,
                          361
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -124,
                          -128
                        ]
                      }
                    ],
                    "colName": "Q1",
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          300,
                          486
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          395,
                          493
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          481,
                          700
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          580,
                          951
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          210,
                          422
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -98,
                          -172
                        ]
                      }
                    ],
                    "colName": "Q2",
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          176,
                          310
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          249,
                          304
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          380,
                          424
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          320,
                          526
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          171,
                          188
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -81,
                          -123
                        ]
                      }
                    ],
                    "colName": "",
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          437
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          455
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          629
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          854
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          310
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -166
                        ]
                      }
                    ],
                    "colName": "Q3",
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          349
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          403
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          527
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          713
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          224
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -125
                        ]
                      }
                    ],
                    "colName": "Q4",
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q1",
                        "compare": {
                          "value": 1156,
                          "percent": null
                        },
                        "current": {
                          "value": 890,
                          "percent": -23
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q2",
                        "compare": {
                          "value": 1373,
                          "percent": null
                        },
                        "current": {
                          "value": 790,
                          "percent": -42
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q3",
                        "compare": {
                          "value": 1164,
                          "percent": null
                        },
                        "current": {
                          "value": 491,
                          "percent": -31
                        },
                        "partial": {
                          "value": 714,
                          "percent": null
                        },
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q4",
                        "compare": {
                          "value": 937,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q1",
                        "compare": {
                          "value": 1497,
                          "percent": null
                        },
                        "current": {
                          "value": 1349,
                          "percent": -10
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q2",
                        "compare": {
                          "value": 1679,
                          "percent": null
                        },
                        "current": {
                          "value": 1177,
                          "percent": -30
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q3",
                        "compare": {
                          "value": 1521,
                          "percent": null
                        },
                        "current": {
                          "value": 804,
                          "percent": -22
                        },
                        "partial": {
                          "value": 1038,
                          "percent": null
                        },
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q4",
                        "compare": {
                          "value": 1279,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 890,
                        "colName": "Q1",
                        "percent": 40,
                        "valueCompare": 1156,
                        "percentCompare": 44
                      },
                      {
                        "title": "Specialties",
                        "value": 1349,
                        "colName": "Q1",
                        "percent": 60,
                        "valueCompare": 1497,
                        "percentCompare": 56
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 790,
                        "colName": "Q2",
                        "percent": 40,
                        "valueCompare": 1373,
                        "percentCompare": 45
                      },
                      {
                        "title": "Specialties",
                        "value": 1177,
                        "colName": "Q2",
                        "percent": 60,
                        "valueCompare": 1679,
                        "percentCompare": 55
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 491,
                        "colName": "",
                        "percent": 38,
                        "valueCompare": 714,
                        "percentCompare": 41
                      },
                      {
                        "title": "Specialties",
                        "value": 804,
                        "colName": "",
                        "percent": 62,
                        "valueCompare": 1038,
                        "percentCompare": 59
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": "Q3",
                        "percent": 0,
                        "valueCompare": 1164,
                        "percentCompare": 43
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": "Q3",
                        "percent": 0,
                        "valueCompare": 1521,
                        "percentCompare": 57
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": "Q4",
                        "percent": 0,
                        "valueCompare": 937,
                        "percentCompare": 42
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": "Q4",
                        "percent": 0,
                        "valueCompare": 1279,
                        "percentCompare": 58
                      }
                    ],
                    "isCompare": true
                  }
                ],
                "isMainGraph": true
              },
              "title": "LY"
            },
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          361,
                          349
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          425,
                          403
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          564,
                          527
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          601,
                          713
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          289,
                          224
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -124,
                          -125
                        ]
                      }
                    ],
                    "colName": "Q1",
                    "rowNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          300,
                          361
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          395,
                          425
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          481,
                          564
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          580,
                          601
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          210,
                          289
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -98,
                          -124
                        ]
                      }
                    ],
                    "colName": "Q2",
                    "rowNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          176,
                          209
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          249,
                          265
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          380,
                          310
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          320,
                          346
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          171,
                          106
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -81,
                          -61
                        ]
                      }
                    ],
                    "colName": "",
                    "rowNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          300
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          395
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          481
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          580
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          210
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -98
                        ]
                      }
                    ],
                    "colName": "Q3",
                    "rowNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          0
                        ]
                      }
                    ],
                    "colName": "Q4",
                    "rowNames": [
                      "ACT",
                      "LQ"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q1",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 890,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q2",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 790,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q3",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 491,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q4",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q1",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 1349,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q2",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 1177,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q3",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 804,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q4",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 890,
                        "colName": "Q1",
                        "percent": 40,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 1349,
                        "colName": "Q1",
                        "percent": 60,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 790,
                        "colName": "Q2",
                        "percent": 40,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 1177,
                        "colName": "Q2",
                        "percent": 60,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 491,
                        "colName": "",
                        "percent": 38,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 804,
                        "colName": "",
                        "percent": 62,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": "Q3",
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": "Q3",
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": "Q4",
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": "Q4",
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  }
                ],
                "isMainGraph": true
              },
              "title": ""
            },
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          361,
                          358
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          425,
                          428
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          564,
                          508
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          601,
                          651
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          289,
                          243
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -124,
                          -145
                        ]
                      }
                    ],
                    "colName": "Q1",
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          300,
                          372
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          395,
                          431
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          481,
                          520
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          580,
                          636
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          210,
                          246
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -98,
                          -145
                        ]
                      }
                    ],
                    "colName": "Q2",
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          176,
                          262
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          249,
                          291
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          380,
                          388
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          320,
                          474
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          171,
                          156
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -81,
                          -97
                        ]
                      }
                    ],
                    "colName": "",
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          393
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          436
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          582
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          711
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          234
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -146
                        ]
                      }
                    ],
                    "colName": "Q3",
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          377
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          415
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          540
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          631
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          192
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -148
                        ]
                      }
                    ],
                    "colName": "Q4",
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q1",
                        "compare": {
                          "value": 894,
                          "percent": null
                        },
                        "current": {
                          "value": 890,
                          "percent": 0
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q2",
                        "compare": {
                          "value": 882,
                          "percent": null
                        },
                        "current": {
                          "value": 790,
                          "percent": -10
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q3",
                        "compare": {
                          "value": 945,
                          "percent": null
                        },
                        "current": {
                          "value": 491,
                          "percent": -22
                        },
                        "partial": {
                          "value": 630,
                          "percent": null
                        },
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q4",
                        "compare": {
                          "value": 823,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q1",
                        "compare": {
                          "value": 1294,
                          "percent": null
                        },
                        "current": {
                          "value": 1349,
                          "percent": 4
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q2",
                        "compare": {
                          "value": 1323,
                          "percent": null
                        },
                        "current": {
                          "value": 1177,
                          "percent": -11
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q3",
                        "compare": {
                          "value": 1411,
                          "percent": null
                        },
                        "current": {
                          "value": 804,
                          "percent": -15
                        },
                        "partial": {
                          "value": 941,
                          "percent": null
                        },
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q4",
                        "compare": {
                          "value": 1332,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 890,
                        "colName": "Q1",
                        "percent": 40,
                        "valueCompare": 894,
                        "percentCompare": 41
                      },
                      {
                        "title": "Specialties",
                        "value": 1349,
                        "colName": "Q1",
                        "percent": 60,
                        "valueCompare": 1294,
                        "percentCompare": 59
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 790,
                        "colName": "Q2",
                        "percent": 40,
                        "valueCompare": 882,
                        "percentCompare": 40
                      },
                      {
                        "title": "Specialties",
                        "value": 1177,
                        "colName": "Q2",
                        "percent": 60,
                        "valueCompare": 1323,
                        "percentCompare": 60
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 491,
                        "colName": "",
                        "percent": 38,
                        "valueCompare": 630,
                        "percentCompare": 40
                      },
                      {
                        "title": "Specialties",
                        "value": 804,
                        "colName": "",
                        "percent": 62,
                        "valueCompare": 941,
                        "percentCompare": 60
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": "Q3",
                        "percent": 0,
                        "valueCompare": 945,
                        "percentCompare": 40
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": "Q3",
                        "percent": 0,
                        "valueCompare": 1411,
                        "percentCompare": 60
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": "Q4",
                        "percent": 0,
                        "valueCompare": 823,
                        "percentCompare": 38
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": "Q4",
                        "percent": 0,
                        "valueCompare": 1332,
                        "percentCompare": 62
                      }
                    ],
                    "isCompare": true
                  }
                ],
                "isMainGraph": true
              },
              "title": "BGT"
            }
          ],
          "ytd": [
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          130,
                          172
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          143,
                          147
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          170,
                          165
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          146,
                          108
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          89,
                          84
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -45,
                          -42
                        ]
                      }
                    ],
                    "colName": 1,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          254,
                          336
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          278,
                          279
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          342,
                          348
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          287,
                          352
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          201,
                          208
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -86,
                          -82
                        ]
                      }
                    ],
                    "colName": 2,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          361,
                          494
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          425,
                          437
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          564,
                          566
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          601,
                          795
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          289,
                          361
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -124,
                          -128
                        ]
                      }
                    ],
                    "colName": 3,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          463,
                          657
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          554,
                          598
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          711,
                          771
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          734,
                          963
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          333,
                          486
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -158,
                          -174
                        ]
                      }
                    ],
                    "colName": 4,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          570,
                          816
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          690,
                          767
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          874,
                          1032
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          929,
                          1374
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          396,
                          625
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -186,
                          -239
                        ]
                      }
                    ],
                    "colName": 5,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          661,
                          980
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          820,
                          930
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          1045,
                          1266
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          1181,
                          1746
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          499,
                          783
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -222,
                          -300
                        ]
                      }
                    ],
                    "colName": 6,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          751,
                          1140
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          947,
                          1082
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          1227,
                          1466
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          1289,
                          1998
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          586,
                          863
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -262,
                          -368
                        ]
                      }
                    ],
                    "colName": 7,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          837,
                          1290
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          1069,
                          1234
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          1425,
                          1690
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          1449,
                          2272
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          669,
                          972
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -302,
                          -424
                        ]
                      }
                    ],
                    "colName": 8,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          1417
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          1385
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          1895
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          2600
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          1094
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -467
                        ]
                      }
                    ],
                    "colName": 9,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          1527
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          1526
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          2100
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          2739
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          1148
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -517
                        ]
                      }
                    ],
                    "colName": 10,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          1664
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          1663
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          2282
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          3027
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          1204
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -561
                        ]
                      }
                    ],
                    "colName": 11,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          1766
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          1788
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          2422
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          3313
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          1318
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -592
                        ]
                      }
                    ],
                    "colName": 12,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 192,
                          "percent": null
                        },
                        "current": {
                          "value": 235,
                          "percent": 23
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 560,
                          "percent": null
                        },
                        "current": {
                          "value": 488,
                          "percent": -13
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 1156,
                          "percent": null
                        },
                        "current": {
                          "value": 890,
                          "percent": -23
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 1449,
                          "percent": null
                        },
                        "current": {
                          "value": 1068,
                          "percent": -26
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 1999,
                          "percent": null
                        },
                        "current": {
                          "value": 1325,
                          "percent": -34
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 2530,
                          "percent": null
                        },
                        "current": {
                          "value": 1680,
                          "percent": -34
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 2861,
                          "percent": null
                        },
                        "current": {
                          "value": 1875,
                          "percent": -34
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 3244,
                          "percent": null
                        },
                        "current": {
                          "value": 2119,
                          "percent": -35
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 3694,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 3887,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 4232,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 4630,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 485,
                          "percent": null
                        },
                        "current": {
                          "value": 443,
                          "percent": -9
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 963,
                          "percent": null
                        },
                        "current": {
                          "value": 874,
                          "percent": -9
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 1497,
                          "percent": null
                        },
                        "current": {
                          "value": 1349,
                          "percent": -10
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 2026,
                          "percent": null
                        },
                        "current": {
                          "value": 1727,
                          "percent": -15
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 2615,
                          "percent": null
                        },
                        "current": {
                          "value": 2134,
                          "percent": -18
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 3176,
                          "percent": null
                        },
                        "current": {
                          "value": 2526,
                          "percent": -20
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 3689,
                          "percent": null
                        },
                        "current": {
                          "value": 2926,
                          "percent": -21
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 4214,
                          "percent": null
                        },
                        "current": {
                          "value": 3330,
                          "percent": -21
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 4697,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 5153,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 5609,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 5976,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 235,
                        "colName": 1,
                        "percent": 35,
                        "valueCompare": 192,
                        "percentCompare": 28
                      },
                      {
                        "title": "Specialties",
                        "value": 443,
                        "colName": 1,
                        "percent": 65,
                        "valueCompare": 485,
                        "percentCompare": 72
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 488,
                        "colName": 2,
                        "percent": 36,
                        "valueCompare": 560,
                        "percentCompare": 37
                      },
                      {
                        "title": "Specialties",
                        "value": 874,
                        "colName": 2,
                        "percent": 64,
                        "valueCompare": 963,
                        "percentCompare": 63
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 890,
                        "colName": 3,
                        "percent": 40,
                        "valueCompare": 1156,
                        "percentCompare": 44
                      },
                      {
                        "title": "Specialties",
                        "value": 1349,
                        "colName": 3,
                        "percent": 60,
                        "valueCompare": 1497,
                        "percentCompare": 56
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 1068,
                        "colName": 4,
                        "percent": 38,
                        "valueCompare": 1449,
                        "percentCompare": 42
                      },
                      {
                        "title": "Specialties",
                        "value": 1727,
                        "colName": 4,
                        "percent": 62,
                        "valueCompare": 2026,
                        "percentCompare": 58
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 1325,
                        "colName": 5,
                        "percent": 38,
                        "valueCompare": 1999,
                        "percentCompare": 43
                      },
                      {
                        "title": "Specialties",
                        "value": 2134,
                        "colName": 5,
                        "percent": 62,
                        "valueCompare": 2615,
                        "percentCompare": 57
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 1680,
                        "colName": 6,
                        "percent": 40,
                        "valueCompare": 2530,
                        "percentCompare": 44
                      },
                      {
                        "title": "Specialties",
                        "value": 2526,
                        "colName": 6,
                        "percent": 60,
                        "valueCompare": 3176,
                        "percentCompare": 56
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 1875,
                        "colName": 7,
                        "percent": 39,
                        "valueCompare": 2861,
                        "percentCompare": 44
                      },
                      {
                        "title": "Specialties",
                        "value": 2926,
                        "colName": 7,
                        "percent": 61,
                        "valueCompare": 3689,
                        "percentCompare": 56
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 2119,
                        "colName": 8,
                        "percent": 39,
                        "valueCompare": 3244,
                        "percentCompare": 43
                      },
                      {
                        "title": "Specialties",
                        "value": 3330,
                        "colName": 8,
                        "percent": 61,
                        "valueCompare": 4214,
                        "percentCompare": 57
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 3694,
                        "percentCompare": 44
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 4697,
                        "percentCompare": 56
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 3887,
                        "percentCompare": 43
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 5153,
                        "percentCompare": 57
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 4232,
                        "percentCompare": 43
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 5609,
                        "percentCompare": 57
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 4630,
                        "percentCompare": 44
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 5976,
                        "percentCompare": 56
                      }
                    ],
                    "isCompare": true
                  }
                ],
                "isMainGraph": true
              },
              "title": "LY"
            },
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          130
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          143
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          170
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          146
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          89
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -45
                        ]
                      }
                    ],
                    "colName": 1,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          254
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          278
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          342
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          287
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          201
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -86
                        ]
                      }
                    ],
                    "colName": 2,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          361
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          425
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          564
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          601
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          289
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -124
                        ]
                      }
                    ],
                    "colName": 3,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          463
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          554
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          711
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          734
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          333
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -158
                        ]
                      }
                    ],
                    "colName": 4,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          570
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          690
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          874
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          929
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          396
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -186
                        ]
                      }
                    ],
                    "colName": 5,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          661
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          820
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          1045
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          1181
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          499
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -222
                        ]
                      }
                    ],
                    "colName": 6,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          751
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          947
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          1227
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          1289
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          586
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -262
                        ]
                      }
                    ],
                    "colName": 7,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          837
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          1069
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          1425
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          1449
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          669
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -302
                        ]
                      }
                    ],
                    "colName": 8,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0
                        ]
                      }
                    ],
                    "colName": 9,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0
                        ]
                      }
                    ],
                    "colName": 10,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0
                        ]
                      }
                    ],
                    "colName": 11,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0
                        ]
                      }
                    ],
                    "colName": 12,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 235,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 488,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 890,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 1068,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 1325,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 1680,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 1875,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 2119,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 443,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 874,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 1349,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 1727,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 2134,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 2526,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 2926,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 3330,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 235,
                        "colName": 1,
                        "percent": 35,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 443,
                        "colName": 1,
                        "percent": 65,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 488,
                        "colName": 2,
                        "percent": 36,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 874,
                        "colName": 2,
                        "percent": 64,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 890,
                        "colName": 3,
                        "percent": 40,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 1349,
                        "colName": 3,
                        "percent": 60,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 1068,
                        "colName": 4,
                        "percent": 38,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 1727,
                        "colName": 4,
                        "percent": 62,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 1325,
                        "colName": 5,
                        "percent": 38,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 2134,
                        "colName": 5,
                        "percent": 62,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 1680,
                        "colName": 6,
                        "percent": 40,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 2526,
                        "colName": 6,
                        "percent": 60,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 1875,
                        "colName": 7,
                        "percent": 39,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 2926,
                        "colName": 7,
                        "percent": 61,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 2119,
                        "colName": 8,
                        "percent": 39,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 3330,
                        "colName": 8,
                        "percent": 61,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  }
                ],
                "isMainGraph": true
              },
              "title": ""
            },
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          130,
                          119
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          143,
                          143
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          170,
                          169
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          146,
                          217
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          89,
                          81
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -45,
                          -48
                        ]
                      }
                    ],
                    "colName": 1,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          254,
                          239
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          278,
                          286
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          342,
                          339
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          287,
                          433
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          201,
                          162
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -86,
                          -97
                        ]
                      }
                    ],
                    "colName": 2,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          361,
                          358
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          425,
                          428
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          564,
                          508
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          601,
                          651
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          289,
                          243
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -124,
                          -145
                        ]
                      }
                    ],
                    "colName": 3,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          463,
                          482
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          554,
                          571
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          711,
                          682
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          734,
                          862
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          333,
                          325
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -158,
                          -194
                        ]
                      }
                    ],
                    "colName": 4,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          570,
                          606
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          690,
                          715
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          874,
                          855
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          929,
                          1074
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          396,
                          407
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -186,
                          -241
                        ]
                      }
                    ],
                    "colName": 5,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          661,
                          730
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          820,
                          859
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          1045,
                          1028
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          1181,
                          1287
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          499,
                          489
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -222,
                          -290
                        ]
                      }
                    ],
                    "colName": 6,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          751,
                          861
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          947,
                          1004
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          1227,
                          1222
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          1289,
                          1524
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          586,
                          567
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -262,
                          -339
                        ]
                      }
                    ],
                    "colName": 7,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          837,
                          992
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          1069,
                          1150
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          1425,
                          1416
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          1449,
                          1761
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          669,
                          645
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -302,
                          -387
                        ]
                      }
                    ],
                    "colName": 8,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          1123
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          1295
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          1610
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          1998
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          723
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -436
                        ]
                      }
                    ],
                    "colName": 9,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          1249
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          1434
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          1790
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          2208
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          787
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -485
                        ]
                      }
                    ],
                    "colName": 10,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          1374
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          1572
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          1970
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          2419
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          851
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -535
                        ]
                      }
                    ],
                    "colName": 11,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          1500
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          1710
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          2150
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          2629
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          915
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -584
                        ]
                      }
                    ],
                    "colName": 12,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 298,
                          "percent": null
                        },
                        "current": {
                          "value": 235,
                          "percent": -21
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 595,
                          "percent": null
                        },
                        "current": {
                          "value": 488,
                          "percent": -18
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 894,
                          "percent": null
                        },
                        "current": {
                          "value": 890,
                          "percent": 0
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 1187,
                          "percent": null
                        },
                        "current": {
                          "value": 1068,
                          "percent": -10
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 1481,
                          "percent": null
                        },
                        "current": {
                          "value": 1325,
                          "percent": -11
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 1776,
                          "percent": null
                        },
                        "current": {
                          "value": 1680,
                          "percent": -5
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 2091,
                          "percent": null
                        },
                        "current": {
                          "value": 1875,
                          "percent": -10
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 2406,
                          "percent": null
                        },
                        "current": {
                          "value": 2119,
                          "percent": -12
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 2721,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 2995,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 3270,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 3544,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 431,
                          "percent": null
                        },
                        "current": {
                          "value": 443,
                          "percent": 3
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 864,
                          "percent": null
                        },
                        "current": {
                          "value": 874,
                          "percent": 1
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 1294,
                          "percent": null
                        },
                        "current": {
                          "value": 1349,
                          "percent": 4
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 1735,
                          "percent": null
                        },
                        "current": {
                          "value": 1727,
                          "percent": 0
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 2176,
                          "percent": null
                        },
                        "current": {
                          "value": 2134,
                          "percent": -2
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 2617,
                          "percent": null
                        },
                        "current": {
                          "value": 2526,
                          "percent": -3
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 3087,
                          "percent": null
                        },
                        "current": {
                          "value": 2926,
                          "percent": -5
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 3558,
                          "percent": null
                        },
                        "current": {
                          "value": 3330,
                          "percent": -6
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 4028,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 4473,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 4916,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 5360,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 235,
                        "colName": 1,
                        "percent": 35,
                        "valueCompare": 298,
                        "percentCompare": 41
                      },
                      {
                        "title": "Specialties",
                        "value": 443,
                        "colName": 1,
                        "percent": 65,
                        "valueCompare": 431,
                        "percentCompare": 59
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 488,
                        "colName": 2,
                        "percent": 36,
                        "valueCompare": 595,
                        "percentCompare": 41
                      },
                      {
                        "title": "Specialties",
                        "value": 874,
                        "colName": 2,
                        "percent": 64,
                        "valueCompare": 864,
                        "percentCompare": 59
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 890,
                        "colName": 3,
                        "percent": 40,
                        "valueCompare": 894,
                        "percentCompare": 41
                      },
                      {
                        "title": "Specialties",
                        "value": 1349,
                        "colName": 3,
                        "percent": 60,
                        "valueCompare": 1294,
                        "percentCompare": 59
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 1068,
                        "colName": 4,
                        "percent": 38,
                        "valueCompare": 1187,
                        "percentCompare": 41
                      },
                      {
                        "title": "Specialties",
                        "value": 1727,
                        "colName": 4,
                        "percent": 62,
                        "valueCompare": 1735,
                        "percentCompare": 59
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 1325,
                        "colName": 5,
                        "percent": 38,
                        "valueCompare": 1481,
                        "percentCompare": 40
                      },
                      {
                        "title": "Specialties",
                        "value": 2134,
                        "colName": 5,
                        "percent": 62,
                        "valueCompare": 2176,
                        "percentCompare": 60
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 1680,
                        "colName": 6,
                        "percent": 40,
                        "valueCompare": 1776,
                        "percentCompare": 40
                      },
                      {
                        "title": "Specialties",
                        "value": 2526,
                        "colName": 6,
                        "percent": 60,
                        "valueCompare": 2617,
                        "percentCompare": 60
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 1875,
                        "colName": 7,
                        "percent": 39,
                        "valueCompare": 2091,
                        "percentCompare": 40
                      },
                      {
                        "title": "Specialties",
                        "value": 2926,
                        "colName": 7,
                        "percent": 61,
                        "valueCompare": 3087,
                        "percentCompare": 60
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 2119,
                        "colName": 8,
                        "percent": 39,
                        "valueCompare": 2406,
                        "percentCompare": 40
                      },
                      {
                        "title": "Specialties",
                        "value": 3330,
                        "colName": 8,
                        "percent": 61,
                        "valueCompare": 3558,
                        "percentCompare": 60
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 2721,
                        "percentCompare": 40
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 4028,
                        "percentCompare": 60
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 2995,
                        "percentCompare": 40
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 4473,
                        "percentCompare": 60
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 3270,
                        "percentCompare": 40
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 4916,
                        "percentCompare": 60
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 3544,
                        "percentCompare": 40
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 5360,
                        "percentCompare": 60
                      }
                    ],
                    "isCompare": true
                  }
                ],
                "isMainGraph": true
              },
              "title": "BGT"
            }
          ],
          "month": [
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          130,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          143,
                          147
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          170,
                          165
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          146,
                          108
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          89,
                          84
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -45,
                          -42
                        ]
                      }
                    ],
                    "colName": 1,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          124,
                          163
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          134,
                          132
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          173,
                          183
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          141,
                          244
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          112,
                          124
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -40,
                          -39
                        ]
                      }
                    ],
                    "colName": 2,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          106,
                          159
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          147,
                          158
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          221,
                          218
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          314,
                          443
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          88,
                          153
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -36,
                          -46
                        ]
                      }
                    ],
                    "colName": 3,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          102,
                          162
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          129,
                          161
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          147,
                          205
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          152,
                          168
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          44,
                          125
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -36,
                          -46
                        ]
                      }
                    ],
                    "colName": 4,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          107,
                          159
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          136,
                          168
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          163,
                          261
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          195,
                          411
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          62,
                          139
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -27,
                          -63
                        ]
                      }
                    ],
                    "colName": 5,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          91,
                          164
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          130,
                          163
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          171,
                          234
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          234,
                          373
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          103,
                          158
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -37,
                          -62
                        ]
                      }
                    ],
                    "colName": 6,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          91,
                          160
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          127,
                          152
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          182,
                          200
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          160,
                          252
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          87,
                          80
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -41,
                          -69
                        ]
                      }
                    ],
                    "colName": 7,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          85,
                          150
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          122,
                          152
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          197,
                          224
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          160,
                          274
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          83,
                          108
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -38,
                          -54
                        ]
                      }
                    ],
                    "colName": 8,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          127
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          151
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          205
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          328
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          122
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -44
                        ]
                      }
                    ],
                    "colName": 9,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          110
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          141
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          205
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          139
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          54
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -50
                        ]
                      }
                    ],
                    "colName": 10,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          137
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          137
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          182
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          288
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          56
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -43
                        ]
                      }
                    ],
                    "colName": 11,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          101
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          126
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          140
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          286
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          113
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -31
                        ]
                      }
                    ],
                    "colName": 12,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 192,
                          "percent": null
                        },
                        "current": {
                          "value": 235,
                          "percent": 23
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 368,
                          "percent": null
                        },
                        "current": {
                          "value": 253,
                          "percent": -31
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 596,
                          "percent": null
                        },
                        "current": {
                          "value": 402,
                          "percent": -33
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 293,
                          "percent": null
                        },
                        "current": {
                          "value": 196,
                          "percent": -33
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 550,
                          "percent": null
                        },
                        "current": {
                          "value": 257,
                          "percent": -53
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 531,
                          "percent": null
                        },
                        "current": {
                          "value": 337,
                          "percent": -37
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 332,
                          "percent": null
                        },
                        "current": {
                          "value": 248,
                          "percent": -25
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 382,
                          "percent": null
                        },
                        "current": {
                          "value": 243,
                          "percent": -36
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 450,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 193,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 345,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 399,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 485,
                          "percent": null
                        },
                        "current": {
                          "value": 443,
                          "percent": -9
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 478,
                          "percent": null
                        },
                        "current": {
                          "value": 431,
                          "percent": -10
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 534,
                          "percent": null
                        },
                        "current": {
                          "value": 475,
                          "percent": -11
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 529,
                          "percent": null
                        },
                        "current": {
                          "value": 378,
                          "percent": -28
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 589,
                          "percent": null
                        },
                        "current": {
                          "value": 406,
                          "percent": -31
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 561,
                          "percent": null
                        },
                        "current": {
                          "value": 392,
                          "percent": -30
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 513,
                          "percent": null
                        },
                        "current": {
                          "value": 400,
                          "percent": -22
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 525,
                          "percent": null
                        },
                        "current": {
                          "value": 405,
                          "percent": -23
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 483,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 456,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 456,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 367,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 235,
                        "colName": 1,
                        "percent": 5,
                        "valueCompare": 192,
                        "percentCompare": 28
                      },
                      {
                        "title": "Specialties",
                        "value": 443,
                        "colName": 1,
                        "percent": 95,
                        "valueCompare": 485,
                        "percentCompare": 72
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 253,
                        "colName": 2,
                        "percent": 37,
                        "valueCompare": 368,
                        "percentCompare": 43
                      },
                      {
                        "title": "Specialties",
                        "value": 431,
                        "colName": 2,
                        "percent": 63,
                        "valueCompare": 478,
                        "percentCompare": 57
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 402,
                        "colName": 3,
                        "percent": 46,
                        "valueCompare": 596,
                        "percentCompare": 53
                      },
                      {
                        "title": "Specialties",
                        "value": 475,
                        "colName": 3,
                        "percent": 54,
                        "valueCompare": 534,
                        "percentCompare": 47
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 196,
                        "colName": 4,
                        "percent": 34,
                        "valueCompare": 293,
                        "percentCompare": 36
                      },
                      {
                        "title": "Specialties",
                        "value": 378,
                        "colName": 4,
                        "percent": 66,
                        "valueCompare": 529,
                        "percentCompare": 64
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 257,
                        "colName": 5,
                        "percent": 39,
                        "valueCompare": 550,
                        "percentCompare": 48
                      },
                      {
                        "title": "Specialties",
                        "value": 406,
                        "colName": 5,
                        "percent": 61,
                        "valueCompare": 589,
                        "percentCompare": 52
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 337,
                        "colName": 6,
                        "percent": 46,
                        "valueCompare": 531,
                        "percentCompare": 49
                      },
                      {
                        "title": "Specialties",
                        "value": 392,
                        "colName": 6,
                        "percent": 54,
                        "valueCompare": 561,
                        "percentCompare": 51
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 248,
                        "colName": 7,
                        "percent": 38,
                        "valueCompare": 332,
                        "percentCompare": 39
                      },
                      {
                        "title": "Specialties",
                        "value": 400,
                        "colName": 7,
                        "percent": 62,
                        "valueCompare": 513,
                        "percentCompare": 61
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 243,
                        "colName": 8,
                        "percent": 38,
                        "valueCompare": 382,
                        "percentCompare": 42
                      },
                      {
                        "title": "Specialties",
                        "value": 405,
                        "colName": 8,
                        "percent": 62,
                        "valueCompare": 525,
                        "percentCompare": 58
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 450,
                        "percentCompare": 48
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 483,
                        "percentCompare": 52
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 193,
                        "percentCompare": 30
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 456,
                        "percentCompare": 70
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 345,
                        "percentCompare": 43
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 456,
                        "percentCompare": 57
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 399,
                        "percentCompare": 52
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 367,
                        "percentCompare": 48
                      }
                    ],
                    "isCompare": true
                  }
                ],
                "defaultPieGraphIndex": 1,
                "isMainGraph": true
              },
              "title": "LY"
            },
            {
              "graph": {
                "data": null,
                "defaultPieGraphIndex": 1,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          1305,
                          1015
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          1438,
                          1265
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          1705,
                          1404
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          1462,
                          2862
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          8952,
                          1132
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -45,
                          -31
                        ]
                      }
                    ],
                    "colName": 1,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          124,
                          130
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          134,
                          143
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          173,
                          170
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          141,
                          146
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          112,
                          89
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -40,
                          -45
                        ]
                      }
                    ],
                    "colName": 2,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          106,
                          124
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          147,
                          134
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          221,
                          173
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          314,
                          141
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          88,
                          112
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -36,
                          -40
                        ]
                      }
                    ],
                    "colName": 3,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          102,
                          106
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          129,
                          147
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          147,
                          221
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          152,
                          314
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          44,
                          88
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -36,
                          -36
                        ]
                      }
                    ],
                    "colName": 4,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          107,
                          102
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          136,
                          129
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          163,
                          147
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          195,
                          152
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          62,
                          44
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -27,
                          -36
                        ]
                      }
                    ],
                    "colName": 5,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          91,
                          107
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          130,
                          136
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          171,
                          163
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          234,
                          195
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          103,
                          62
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -37,
                          -27
                        ]
                      }
                    ],
                    "colName": 6,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          91,
                          91
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          127,
                          130
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          182,
                          171
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          160,
                          234
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          87,
                          103
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -41,
                          -37
                        ]
                      }
                    ],
                    "colName": 7,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          85,
                          91
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          122,
                          127
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          197,
                          182
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          160,
                          160
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          83,
                          87
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -38,
                          -41
                        ]
                      }
                    ],
                    "colName": 8,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          85
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          122
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          197
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          160
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          83
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -38
                        ]
                      }
                    ],
                    "colName": 9,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          0
                        ]
                      }
                    ],
                    "colName": 10,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          0
                        ]
                      }
                    ],
                    "colName": 11,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          0
                        ]
                      }
                    ],
                    "colName": 12,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": null,
                        "current": {
                          "value": 235,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": null,
                        "current": {
                          "value": 253,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": null,
                        "current": {
                          "value": 402,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": null,
                        "current": {
                          "value": 196,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": null,
                        "current": {
                          "value": 257,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": null,
                        "current": {
                          "value": 337,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": null,
                        "current": {
                          "value": 248,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": null,
                        "current": {
                          "value": 243,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": null,
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": null,
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": null,
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": null,
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 443,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 431,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 475,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 378,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 406,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 392,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 400,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 405,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 20,
                        "colName": 1,
                        "percent": 5,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 443,
                        "colName": 1,
                        "percent": 95,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 253,
                        "colName": 2,
                        "percent": 37,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 431,
                        "colName": 2,
                        "percent": 63,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 402,
                        "colName": 3,
                        "percent": 46,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 475,
                        "colName": 3,
                        "percent": 54,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 196,
                        "colName": 4,
                        "percent": 34,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 378,
                        "colName": 4,
                        "percent": 66,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 257,
                        "colName": 5,
                        "percent": 39,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 406,
                        "colName": 5,
                        "percent": 61,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 337,
                        "colName": 6,
                        "percent": 46,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 392,
                        "colName": 6,
                        "percent": 54,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 248,
                        "colName": 7,
                        "percent": 38,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 400,
                        "colName": 7,
                        "percent": 62,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 243,
                        "colName": 8,
                        "percent": 38,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 405,
                        "colName": 8,
                        "percent": 62,
                        "valueCompare": null,
                        "percentCompare": null,
                        "isDefault": true
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  }
                ],
                "isMainGraph": true
              },
              "title": ""
            },
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          130,
                          119
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          143,
                          143
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          170,
                          169
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          146,
                          217
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          89,
                          81
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -45,
                          -48
                        ]
                      }
                    ],
                    "colName": 1,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          124,
                          120
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          134,
                          143
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          173,
                          170
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          141,
                          216
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          112,
                          81
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -40,
                          -49
                        ]
                      }
                    ],
                    "colName": 2,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          106,
                          119
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          147,
                          143
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          221,
                          169
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          314,
                          218
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          88,
                          81
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -36,
                          -48
                        ]
                      }
                    ],
                    "colName": 3,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          102,
                          124
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          129,
                          143
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          147,
                          174
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          152,
                          211
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          44,
                          82
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -36,
                          -49
                        ]
                      }
                    ],
                    "colName": 4,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          107,
                          124
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          136,
                          144
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          163,
                          173
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          195,
                          212
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          62,
                          82
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -27,
                          -47
                        ]
                      }
                    ],
                    "colName": 5,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          91,
                          124
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          130,
                          144
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          171,
                          173
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          234,
                          213
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          103,
                          82
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -37,
                          -49
                        ]
                      }
                    ],
                    "colName": 6,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          91,
                          131
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          127,
                          145
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          182,
                          194
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          160,
                          237
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          87,
                          78
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -41,
                          -49
                        ]
                      }
                    ],
                    "colName": 7,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          85,
                          131
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          122,
                          146
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          197,
                          194
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          160,
                          237
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          83,
                          78
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -38,
                          -48
                        ]
                      }
                    ],
                    "colName": 8,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          131
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          145
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          194
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          237
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          78
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -49
                        ]
                      }
                    ],
                    "colName": 9,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          126
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          139
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          180
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          210
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          64
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -49
                        ]
                      }
                    ],
                    "colName": 10,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          125
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          138
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          180
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          211
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          64
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -50
                        ]
                      }
                    ],
                    "colName": 11,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          126
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          138
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          180
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          210
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          64
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -49
                        ]
                      }
                    ],
                    "colName": 12,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 298,
                          "percent": null
                        },
                        "current": {
                          "value": 235,
                          "percent": -21
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 297,
                          "percent": null
                        },
                        "current": {
                          "value": 253,
                          "percent": -15
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 299,
                          "percent": null
                        },
                        "current": {
                          "value": 402,
                          "percent": 34
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 293,
                          "percent": null
                        },
                        "current": {
                          "value": 196,
                          "percent": -33
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 294,
                          "percent": null
                        },
                        "current": {
                          "value": 257,
                          "percent": -13
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 295,
                          "percent": null
                        },
                        "current": {
                          "value": 337,
                          "percent": 14
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 315,
                          "percent": null
                        },
                        "current": {
                          "value": 248,
                          "percent": -21
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 315,
                          "percent": null
                        },
                        "current": {
                          "value": 243,
                          "percent": -23
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 315,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 274,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 275,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 274,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 431,
                          "percent": null
                        },
                        "current": {
                          "value": 443,
                          "percent": 3
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 433,
                          "percent": null
                        },
                        "current": {
                          "value": 431,
                          "percent": 0
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 431,
                          "percent": null
                        },
                        "current": {
                          "value": 475,
                          "percent": 10
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 441,
                          "percent": null
                        },
                        "current": {
                          "value": 378,
                          "percent": -14
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 441,
                          "percent": null
                        },
                        "current": {
                          "value": 406,
                          "percent": -8
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 441,
                          "percent": null
                        },
                        "current": {
                          "value": 392,
                          "percent": -11
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 470,
                          "percent": null
                        },
                        "current": {
                          "value": 400,
                          "percent": -15
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 471,
                          "percent": null
                        },
                        "current": {
                          "value": 405,
                          "percent": -14
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 470,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 445,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 443,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 444,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 235,
                        "colName": 1,
                        "percent": 35,
                        "valueCompare": 298,
                        "percentCompare": 41
                      },
                      {
                        "title": "Specialties",
                        "value": 443,
                        "colName": 1,
                        "percent": 65,
                        "valueCompare": 431,
                        "percentCompare": 59
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 253,
                        "colName": 2,
                        "percent": 37,
                        "valueCompare": 297,
                        "percentCompare": 41
                      },
                      {
                        "title": "Specialties",
                        "value": 431,
                        "colName": 2,
                        "percent": 63,
                        "valueCompare": 433,
                        "percentCompare": 59
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 402,
                        "colName": 3,
                        "percent": 46,
                        "valueCompare": 299,
                        "percentCompare": 41
                      },
                      {
                        "title": "Specialties",
                        "value": 475,
                        "colName": 3,
                        "percent": 54,
                        "valueCompare": 431,
                        "percentCompare": 59
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 196,
                        "colName": 4,
                        "percent": 34,
                        "valueCompare": 293,
                        "percentCompare": 40
                      },
                      {
                        "title": "Specialties",
                        "value": 378,
                        "colName": 4,
                        "percent": 66,
                        "valueCompare": 441,
                        "percentCompare": 60
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 257,
                        "colName": 5,
                        "percent": 39,
                        "valueCompare": 294,
                        "percentCompare": 40
                      },
                      {
                        "title": "Specialties",
                        "value": 406,
                        "colName": 5,
                        "percent": 61,
                        "valueCompare": 441,
                        "percentCompare": 60
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 337,
                        "colName": 6,
                        "percent": 46,
                        "valueCompare": 295,
                        "percentCompare": 40
                      },
                      {
                        "title": "Specialties",
                        "value": 392,
                        "colName": 6,
                        "percent": 54,
                        "valueCompare": 441,
                        "percentCompare": 60
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 248,
                        "colName": 7,
                        "percent": 38,
                        "valueCompare": 315,
                        "percentCompare": 40
                      },
                      {
                        "title": "Specialties",
                        "value": 400,
                        "colName": 7,
                        "percent": 62,
                        "valueCompare": 470,
                        "percentCompare": 60
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 243,
                        "colName": 8,
                        "percent": 38,
                        "valueCompare": 315,
                        "percentCompare": 40
                      },
                      {
                        "title": "Specialties",
                        "value": 405,
                        "colName": 8,
                        "percent": 62,
                        "valueCompare": 471,
                        "percentCompare": 60
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 315,
                        "percentCompare": 40
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 470,
                        "percentCompare": 60
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 274,
                        "percentCompare": 38
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 445,
                        "percentCompare": 62
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 275,
                        "percentCompare": 38
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 443,
                        "percentCompare": 62
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 274,
                        "percentCompare": 38
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 444,
                        "percentCompare": 62
                      }
                    ],
                    "isCompare": true
                  }
                ],
                "isMainGraph": true
              },
              "title": "BGT"
            }
          ]
        },
        "title": "Sales"
      },
      {
        "data": {
          "qtd": [
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          90,
                          188
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          69,
                          102
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          32,
                          93
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          254,
                          410
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          46,
                          98
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -11,
                          -11
                        ]
                      }
                    ],
                    "colName": "Q1",
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          60,
                          191
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          68,
                          118
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          4,
                          141
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          167,
                          576
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          3,
                          150
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -2,
                          -37
                        ]
                      }
                    ],
                    "colName": "Q2",
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          14,
                          113
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          29,
                          64
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          95
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          58,
                          301
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          4,
                          68
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -9,
                          -18
                        ]
                      }
                    ],
                    "colName": "",
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          154
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          97
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          112
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          496
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          96
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -27
                        ]
                      }
                    ],
                    "colName": "Q3",
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          95
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          66
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          32
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          340
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          49
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -20
                        ]
                      }
                    ],
                    "colName": "Q4",
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q1",
                        "compare": {
                          "value": 508,
                          "percent": null
                        },
                        "current": {
                          "value": 299,
                          "percent": -41
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q2",
                        "compare": {
                          "value": 725,
                          "percent": null
                        },
                        "current": {
                          "value": 170,
                          "percent": -77
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q3",
                        "compare": {
                          "value": 592,
                          "percent": null
                        },
                        "current": {
                          "value": 62,
                          "percent": -83
                        },
                        "partial": {
                          "value": 369,
                          "percent": null
                        },
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q4",
                        "compare": {
                          "value": 389,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q1",
                        "compare": {
                          "value": 383,
                          "percent": null
                        },
                        "current": {
                          "value": 190,
                          "percent": -50
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q2",
                        "compare": {
                          "value": 449,
                          "percent": null
                        },
                        "current": {
                          "value": 132,
                          "percent": -71
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q3",
                        "compare": {
                          "value": 364,
                          "percent": null
                        },
                        "current": {
                          "value": 44,
                          "percent": -84
                        },
                        "partial": {
                          "value": 272,
                          "percent": null
                        },
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q4",
                        "compare": {
                          "value": 194,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 299,
                        "colName": "Q1",
                        "percent": 61,
                        "valueCompare": 508,
                        "percentCompare": 57
                      },
                      {
                        "title": "Specialties",
                        "value": 190,
                        "colName": "Q1",
                        "percent": 39,
                        "valueCompare": 383,
                        "percentCompare": 43
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 170,
                        "colName": "Q2",
                        "percent": 56,
                        "valueCompare": 725,
                        "percentCompare": 62
                      },
                      {
                        "title": "Specialties",
                        "value": 132,
                        "colName": "Q2",
                        "percent": 44,
                        "valueCompare": 449,
                        "percentCompare": 38
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 62,
                        "colName": "",
                        "percent": 59,
                        "valueCompare": 369,
                        "percentCompare": 58
                      },
                      {
                        "title": "Specialties",
                        "value": 44,
                        "colName": "",
                        "percent": 41,
                        "valueCompare": 272,
                        "percentCompare": 42
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": "Q3",
                        "percent": 0,
                        "valueCompare": 592,
                        "percentCompare": 62
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": "Q3",
                        "percent": 0,
                        "valueCompare": 364,
                        "percentCompare": 38
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": "Q4",
                        "percent": 0,
                        "valueCompare": 389,
                        "percentCompare": 67
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": "Q4",
                        "percent": 0,
                        "valueCompare": 194,
                        "percentCompare": 33
                      }
                    ],
                    "isCompare": true
                  }
                ],
                "isMainGraph": true
              },
              "title": "LY"
            },
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          90,
                          95
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          69,
                          66
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          32,
                          32
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          254,
                          340
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          46,
                          49
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -11,
                          -20
                        ]
                      }
                    ],
                    "colName": "Q1",
                    "rowNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          60,
                          90
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          68,
                          69
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          4,
                          32
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          167,
                          254
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          3,
                          46
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -2,
                          -11
                        ]
                      }
                    ],
                    "colName": "Q2",
                    "rowNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          14,
                          33
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          29,
                          42
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          6
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          58,
                          105
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          4,
                          -1
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -9,
                          -12
                        ]
                      }
                    ],
                    "colName": "",
                    "rowNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          60
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          68
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          4
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          167
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          3
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -2
                        ]
                      }
                    ],
                    "colName": "Q3",
                    "rowNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          0
                        ]
                      }
                    ],
                    "colName": "Q4",
                    "rowNames": [
                      "ACT",
                      "LQ"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q1",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 299,
                          "percent": 34
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q2",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 170,
                          "percent": 22
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q3",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 62,
                          "percent": 13
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q4",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q1",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 190,
                          "percent": 14
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q2",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 132,
                          "percent": 11
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q3",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 44,
                          "percent": 5
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q4",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 299,
                        "colName": "Q1",
                        "percent": 61,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 190,
                        "colName": "Q1",
                        "percent": 39,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 170,
                        "colName": "Q2",
                        "percent": 56,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 132,
                        "colName": "Q2",
                        "percent": 44,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 62,
                        "colName": "",
                        "percent": 59,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 44,
                        "colName": "",
                        "percent": 41,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": "Q3",
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": "Q3",
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": "Q4",
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": "Q4",
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  }
                ],
                "isMainGraph": true
              },
              "title": ""
            },
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          90,
                          99
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          69,
                          58
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          32,
                          67
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          254,
                          248
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          46,
                          22
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -11,
                          -42
                        ]
                      }
                    ],
                    "colName": "Q1",
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          60,
                          103
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          68,
                          63
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          4,
                          71
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          167,
                          241
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          3,
                          18
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -2,
                          -43
                        ]
                      }
                    ],
                    "colName": "Q2",
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          14,
                          75
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          29,
                          44
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          50
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          58,
                          202
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          4,
                          13
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -9,
                          -27
                        ]
                      }
                    ],
                    "colName": "",
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          112
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          66
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          76
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          303
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          20
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -42
                        ]
                      }
                    ],
                    "colName": "Q3",
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          106
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          60
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          66
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          262
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          5
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -39
                        ]
                      }
                    ],
                    "colName": "Q4",
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q1",
                        "compare": {
                          "value": 270,
                          "percent": null
                        },
                        "current": {
                          "value": 299,
                          "percent": 11
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q2",
                        "compare": {
                          "value": 259,
                          "percent": null
                        },
                        "current": {
                          "value": 170,
                          "percent": -34
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q3",
                        "compare": {
                          "value": 323,
                          "percent": null
                        },
                        "current": {
                          "value": 62,
                          "percent": -71
                        },
                        "partial": {
                          "value": 215,
                          "percent": null
                        },
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q4",
                        "compare": {
                          "value": 267,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q1",
                        "compare": {
                          "value": 224,
                          "percent": null
                        },
                        "current": {
                          "value": 190,
                          "percent": -15
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q2",
                        "compare": {
                          "value": 237,
                          "percent": null
                        },
                        "current": {
                          "value": 132,
                          "percent": -44
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q3",
                        "compare": {
                          "value": 254,
                          "percent": null
                        },
                        "current": {
                          "value": 44,
                          "percent": -74
                        },
                        "partial": {
                          "value": 169,
                          "percent": null
                        },
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q4",
                        "compare": {
                          "value": 232,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 299,
                        "colName": "Q1",
                        "percent": 61,
                        "valueCompare": 270,
                        "percentCompare": 55
                      },
                      {
                        "title": "Specialties",
                        "value": 190,
                        "colName": "Q1",
                        "percent": 39,
                        "valueCompare": 224,
                        "percentCompare": 45
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 170,
                        "colName": "Q2",
                        "percent": 56,
                        "valueCompare": 259,
                        "percentCompare": 52
                      },
                      {
                        "title": "Specialties",
                        "value": 132,
                        "colName": "Q2",
                        "percent": 44,
                        "valueCompare": 237,
                        "percentCompare": 48
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 62,
                        "colName": "",
                        "percent": 59,
                        "valueCompare": 215,
                        "percentCompare": 56
                      },
                      {
                        "title": "Specialties",
                        "value": 44,
                        "colName": "",
                        "percent": 41,
                        "valueCompare": 169,
                        "percentCompare": 44
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": "Q3",
                        "percent": 0,
                        "valueCompare": 323,
                        "percentCompare": 56
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": "Q3",
                        "percent": 0,
                        "valueCompare": 254,
                        "percentCompare": 44
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": "Q4",
                        "percent": 0,
                        "valueCompare": 267,
                        "percentCompare": 54
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": "Q4",
                        "percent": 0,
                        "valueCompare": 232,
                        "percentCompare": 46
                      }
                    ],
                    "isCompare": true
                  }
                ],
                "isMainGraph": true
              },
              "title": "BGT"
            }
          ],
          "ytd": [
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          31,
                          61
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          23,
                          35
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          14,
                          22
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          54,
                          44
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          14,
                          19
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -8,
                          -12
                        ]
                      }
                    ],
                    "colName": 1,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          63,
                          120
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          44,
                          64
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          18,
                          49
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          102,
                          167
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          27,
                          44
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -19,
                          -12
                        ]
                      }
                    ],
                    "colName": 2,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          90,
                          188
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          69,
                          102
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          32,
                          93
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          254,
                          410
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          46,
                          98
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -11,
                          -11
                        ]
                      }
                    ],
                    "colName": 3,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          103,
                          257
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          91,
                          143
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          36,
                          134
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          297,
                          490
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          41,
                          135
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -16,
                          -20
                        ]
                      }
                    ],
                    "colName": 4,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          123,
                          324
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          111,
                          182
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          37,
                          188
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          358,
                          751
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          45,
                          187
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -20,
                          -33
                        ]
                      }
                    ],
                    "colName": 5,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          150,
                          379
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          137,
                          219
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          36,
                          234
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          421,
                          986
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          49,
                          248
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -13,
                          -47
                        ]
                      }
                    ],
                    "colName": 6,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          157,
                          438
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          152,
                          261
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          31,
                          279
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          458,
                          1134
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          55,
                          281
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -23,
                          -57
                        ]
                      }
                    ],
                    "colName": 7,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          163,
                          492
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          167,
                          284
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          37,
                          328
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          480,
                          1286
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          53,
                          316
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -24,
                          -64
                        ]
                      }
                    ],
                    "colName": 8,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          533
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          317
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          346
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          1482
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          344
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -75
                        ]
                      }
                    ],
                    "colName": 9,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          562
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          345
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          365
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          1534
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          353
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -77
                        ]
                      }
                    ],
                    "colName": 10,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          596
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          366
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          364
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          1682
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          353
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -77
                        ]
                      }
                    ],
                    "colName": 11,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          628
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          383
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          378
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          1822
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          394
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -96
                        ]
                      }
                    ],
                    "colName": 12,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 63,
                          "percent": null
                        },
                        "current": {
                          "value": 68,
                          "percent": 8
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 211,
                          "percent": null
                        },
                        "current": {
                          "value": 129,
                          "percent": -39
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 508,
                          "percent": null
                        },
                        "current": {
                          "value": 299,
                          "percent": -41
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 625,
                          "percent": null
                        },
                        "current": {
                          "value": 338,
                          "percent": -46
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 938,
                          "percent": null
                        },
                        "current": {
                          "value": 403,
                          "percent": -57
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 1234,
                          "percent": null
                        },
                        "current": {
                          "value": 470,
                          "percent": -62
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 1415,
                          "percent": null
                        },
                        "current": {
                          "value": 513,
                          "percent": -64
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 1603,
                          "percent": null
                        },
                        "current": {
                          "value": 532,
                          "percent": -67
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 1826,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 1887,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 2035,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 2216,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 119,
                          "percent": null
                        },
                        "current": {
                          "value": 68,
                          "percent": -43
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 232,
                          "percent": null
                        },
                        "current": {
                          "value": 125,
                          "percent": -46
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 383,
                          "percent": null
                        },
                        "current": {
                          "value": 190,
                          "percent": -50
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 534,
                          "percent": null
                        },
                        "current": {
                          "value": 230,
                          "percent": -57
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 693,
                          "percent": null
                        },
                        "current": {
                          "value": 271,
                          "percent": -61
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 832,
                          "percent": null
                        },
                        "current": {
                          "value": 323,
                          "percent": -61
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 977,
                          "percent": null
                        },
                        "current": {
                          "value": 341,
                          "percent": -65
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 1104,
                          "percent": null
                        },
                        "current": {
                          "value": 367,
                          "percent": -67
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 1196,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 1272,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 1327,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 1389,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 68,
                        "colName": 1,
                        "percent": 50,
                        "valueCompare": 63,
                        "percentCompare": 35
                      },
                      {
                        "title": "Specialties",
                        "value": 68,
                        "colName": 1,
                        "percent": 50,
                        "valueCompare": 119,
                        "percentCompare": 65
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 129,
                        "colName": 2,
                        "percent": 51,
                        "valueCompare": 211,
                        "percentCompare": 48
                      },
                      {
                        "title": "Specialties",
                        "value": 125,
                        "colName": 2,
                        "percent": 49,
                        "valueCompare": 232,
                        "percentCompare": 52
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 299,
                        "colName": 3,
                        "percent": 61,
                        "valueCompare": 508,
                        "percentCompare": 57
                      },
                      {
                        "title": "Specialties",
                        "value": 190,
                        "colName": 3,
                        "percent": 39,
                        "valueCompare": 383,
                        "percentCompare": 43
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 338,
                        "colName": 4,
                        "percent": 60,
                        "valueCompare": 625,
                        "percentCompare": 54
                      },
                      {
                        "title": "Specialties",
                        "value": 230,
                        "colName": 4,
                        "percent": 40,
                        "valueCompare": 534,
                        "percentCompare": 46
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 403,
                        "colName": 5,
                        "percent": 60,
                        "valueCompare": 938,
                        "percentCompare": 58
                      },
                      {
                        "title": "Specialties",
                        "value": 271,
                        "colName": 5,
                        "percent": 40,
                        "valueCompare": 693,
                        "percentCompare": 42
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 470,
                        "colName": 6,
                        "percent": 59,
                        "valueCompare": 1234,
                        "percentCompare": 60
                      },
                      {
                        "title": "Specialties",
                        "value": 323,
                        "colName": 6,
                        "percent": 41,
                        "valueCompare": 832,
                        "percentCompare": 40
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 513,
                        "colName": 7,
                        "percent": 60,
                        "valueCompare": 1415,
                        "percentCompare": 59
                      },
                      {
                        "title": "Specialties",
                        "value": 341,
                        "colName": 7,
                        "percent": 40,
                        "valueCompare": 977,
                        "percentCompare": 41
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 532,
                        "colName": 8,
                        "percent": 59,
                        "valueCompare": 1603,
                        "percentCompare": 59
                      },
                      {
                        "title": "Specialties",
                        "value": 367,
                        "colName": 8,
                        "percent": 41,
                        "valueCompare": 1104,
                        "percentCompare": 41
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 1826,
                        "percentCompare": 60
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 1196,
                        "percentCompare": 40
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 1887,
                        "percentCompare": 60
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 1272,
                        "percentCompare": 40
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 2035,
                        "percentCompare": 61
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 1327,
                        "percentCompare": 39
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 2216,
                        "percentCompare": 61
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 1389,
                        "percentCompare": 39
                      }
                    ],
                    "isCompare": true
                  }
                ],
                "isMainGraph": true
              },
              "title": "LY"
            },
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          31
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          23
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          14
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          54
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          14
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -8
                        ]
                      }
                    ],
                    "colName": 1,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          63
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          44
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          18
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          102
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          27
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -19
                        ]
                      }
                    ],
                    "colName": 2,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          90
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          69
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          32
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          254
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          46
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -11
                        ]
                      }
                    ],
                    "colName": 3,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          103
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          91
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          36
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          297
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          41
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -16
                        ]
                      }
                    ],
                    "colName": 4,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          123
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          111
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          37
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          358
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          45
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -20
                        ]
                      }
                    ],
                    "colName": 5,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          150
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          137
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          36
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          421
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          49
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -13
                        ]
                      }
                    ],
                    "colName": 6,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          157
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          152
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          31
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          458
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          55
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -23
                        ]
                      }
                    ],
                    "colName": 7,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          163
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          167
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          37
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          480
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          53
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -24
                        ]
                      }
                    ],
                    "colName": 8,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0
                        ]
                      }
                    ],
                    "colName": 9,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0
                        ]
                      }
                    ],
                    "colName": 10,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0
                        ]
                      }
                    ],
                    "colName": 11,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0
                        ]
                      }
                    ],
                    "colName": 12,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 68,
                          "percent": 29
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 129,
                          "percent": 26
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 299,
                          "percent": 34
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 338,
                          "percent": 32
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 403,
                          "percent": 30
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 470,
                          "percent": 28
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 513,
                          "percent": 27
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 532,
                          "percent": 25
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 68,
                          "percent": 15
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 125,
                          "percent": 14
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 190,
                          "percent": 14
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 230,
                          "percent": 13
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 271,
                          "percent": 13
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 323,
                          "percent": 13
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 341,
                          "percent": 12
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 367,
                          "percent": 11
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 68,
                        "colName": 1,
                        "percent": 50,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 68,
                        "colName": 1,
                        "percent": 50,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 129,
                        "colName": 2,
                        "percent": 51,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 125,
                        "colName": 2,
                        "percent": 49,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 299,
                        "colName": 3,
                        "percent": 61,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 190,
                        "colName": 3,
                        "percent": 39,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 338,
                        "colName": 4,
                        "percent": 60,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 230,
                        "colName": 4,
                        "percent": 40,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 403,
                        "colName": 5,
                        "percent": 60,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 271,
                        "colName": 5,
                        "percent": 40,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 470,
                        "colName": 6,
                        "percent": 59,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 323,
                        "colName": 6,
                        "percent": 41,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 513,
                        "colName": 7,
                        "percent": 60,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 341,
                        "colName": 7,
                        "percent": 40,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 532,
                        "colName": 8,
                        "percent": 59,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 367,
                        "colName": 8,
                        "percent": 41,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  }
                ],
                "isMainGraph": true
              },
              "title": ""
            },
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          31,
                          33
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          23,
                          19
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          14,
                          22
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          54,
                          83
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          14,
                          8
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -8,
                          -14
                        ]
                      }
                    ],
                    "colName": 1,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          63,
                          66
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          44,
                          39
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          18,
                          45
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          102,
                          165
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          27,
                          14
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -19,
                          -28
                        ]
                      }
                    ],
                    "colName": 2,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          90,
                          99
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          69,
                          58
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          32,
                          67
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          254,
                          248
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          46,
                          22
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -11,
                          -42
                        ]
                      }
                    ],
                    "colName": 3,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          103,
                          133
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          91,
                          79
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          36,
                          90
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          297,
                          328
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          41,
                          28
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -16,
                          -55
                        ]
                      }
                    ],
                    "colName": 4,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          123,
                          167
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          111,
                          100
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          37,
                          114
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          358,
                          408
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          45,
                          34
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -20,
                          -69
                        ]
                      }
                    ],
                    "colName": 5,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          150,
                          202
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          137,
                          121
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          36,
                          138
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          421,
                          489
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          49,
                          40
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -13,
                          -85
                        ]
                      }
                    ],
                    "colName": 6,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          157,
                          239
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          152,
                          143
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          31,
                          163
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          458,
                          590
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          55,
                          46
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -23,
                          -98
                        ]
                      }
                    ],
                    "colName": 7,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          163,
                          277
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          167,
                          165
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          37,
                          188
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          480,
                          691
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          53,
                          53
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -24,
                          -112
                        ]
                      }
                    ],
                    "colName": 8,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          314
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          187
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          214
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          792
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          60
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -127
                        ]
                      }
                    ],
                    "colName": 9,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          349
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          207
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          236
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          879
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          62
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -139
                        ]
                      }
                    ],
                    "colName": 10,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          385
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          227
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          258
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          967
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          63
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -153
                        ]
                      }
                    ],
                    "colName": 11,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          420
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          247
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          280
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          1054
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          65
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -166
                        ]
                      }
                    ],
                    "colName": 12,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 91,
                          "percent": null
                        },
                        "current": {
                          "value": 68,
                          "percent": -25
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 179,
                          "percent": null
                        },
                        "current": {
                          "value": 129,
                          "percent": -28
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 270,
                          "percent": null
                        },
                        "current": {
                          "value": 299,
                          "percent": 11
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 356,
                          "percent": null
                        },
                        "current": {
                          "value": 338,
                          "percent": -5
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 442,
                          "percent": null
                        },
                        "current": {
                          "value": 403,
                          "percent": -9
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 529,
                          "percent": null
                        },
                        "current": {
                          "value": 470,
                          "percent": -11
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 636,
                          "percent": null
                        },
                        "current": {
                          "value": 513,
                          "percent": -19
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 744,
                          "percent": null
                        },
                        "current": {
                          "value": 532,
                          "percent": -28
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 852,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 941,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 1030,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 1119,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 74,
                          "percent": null
                        },
                        "current": {
                          "value": 68,
                          "percent": -9
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 150,
                          "percent": null
                        },
                        "current": {
                          "value": 125,
                          "percent": -17
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 224,
                          "percent": null
                        },
                        "current": {
                          "value": 190,
                          "percent": -15
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 302,
                          "percent": null
                        },
                        "current": {
                          "value": 230,
                          "percent": -24
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 381,
                          "percent": null
                        },
                        "current": {
                          "value": 271,
                          "percent": -29
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 461,
                          "percent": null
                        },
                        "current": {
                          "value": 323,
                          "percent": -30
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 545,
                          "percent": null
                        },
                        "current": {
                          "value": 341,
                          "percent": -38
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 630,
                          "percent": null
                        },
                        "current": {
                          "value": 367,
                          "percent": -42
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 715,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 792,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 870,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 947,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 68,
                        "colName": 1,
                        "percent": 50,
                        "valueCompare": 91,
                        "percentCompare": 55
                      },
                      {
                        "title": "Specialties",
                        "value": 68,
                        "colName": 1,
                        "percent": 50,
                        "valueCompare": 74,
                        "percentCompare": 45
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 129,
                        "colName": 2,
                        "percent": 51,
                        "valueCompare": 179,
                        "percentCompare": 54
                      },
                      {
                        "title": "Specialties",
                        "value": 125,
                        "colName": 2,
                        "percent": 49,
                        "valueCompare": 150,
                        "percentCompare": 46
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 299,
                        "colName": 3,
                        "percent": 61,
                        "valueCompare": 270,
                        "percentCompare": 55
                      },
                      {
                        "title": "Specialties",
                        "value": 190,
                        "colName": 3,
                        "percent": 39,
                        "valueCompare": 224,
                        "percentCompare": 45
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 338,
                        "colName": 4,
                        "percent": 60,
                        "valueCompare": 356,
                        "percentCompare": 54
                      },
                      {
                        "title": "Specialties",
                        "value": 230,
                        "colName": 4,
                        "percent": 40,
                        "valueCompare": 302,
                        "percentCompare": 46
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 403,
                        "colName": 5,
                        "percent": 60,
                        "valueCompare": 442,
                        "percentCompare": 54
                      },
                      {
                        "title": "Specialties",
                        "value": 271,
                        "colName": 5,
                        "percent": 40,
                        "valueCompare": 381,
                        "percentCompare": 46
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 470,
                        "colName": 6,
                        "percent": 59,
                        "valueCompare": 529,
                        "percentCompare": 53
                      },
                      {
                        "title": "Specialties",
                        "value": 323,
                        "colName": 6,
                        "percent": 41,
                        "valueCompare": 461,
                        "percentCompare": 47
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 513,
                        "colName": 7,
                        "percent": 60,
                        "valueCompare": 636,
                        "percentCompare": 54
                      },
                      {
                        "title": "Specialties",
                        "value": 341,
                        "colName": 7,
                        "percent": 40,
                        "valueCompare": 545,
                        "percentCompare": 46
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 532,
                        "colName": 8,
                        "percent": 59,
                        "valueCompare": 744,
                        "percentCompare": 54
                      },
                      {
                        "title": "Specialties",
                        "value": 367,
                        "colName": 8,
                        "percent": 41,
                        "valueCompare": 630,
                        "percentCompare": 46
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 852,
                        "percentCompare": 54
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 715,
                        "percentCompare": 46
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 941,
                        "percentCompare": 54
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 792,
                        "percentCompare": 46
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 1030,
                        "percentCompare": 54
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 870,
                        "percentCompare": 46
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 1119,
                        "percentCompare": 54
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 947,
                        "percentCompare": 46
                      }
                    ],
                    "isCompare": true
                  }
                ],
                "isMainGraph": true
              },
              "title": "BGT"
            }
          ],
          "month": [
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          31,
                          61
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          23,
                          35
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          14,
                          22
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          54,
                          44
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          14,
                          19
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -8,
                          -12
                        ]
                      }
                    ],
                    "colName": 1,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          32,
                          59
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          21,
                          28
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          4,
                          26
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          48,
                          124
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          13,
                          25
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -11,
                          0
                        ]
                      }
                    ],
                    "colName": 2,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          27,
                          68
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          25,
                          38
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          14,
                          44
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          152,
                          243
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          19,
                          55
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          8,
                          0
                        ]
                      }
                    ],
                    "colName": 3,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          14,
                          68
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          22,
                          41
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          4,
                          41
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          44,
                          80
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          -5,
                          37
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -8,
                          -7
                        ]
                      }
                    ],
                    "colName": 4,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          19,
                          67
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          20,
                          39
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          2,
                          54
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          61,
                          262
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          5,
                          52
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -5,
                          -14
                        ]
                      }
                    ],
                    "colName": 5,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          27,
                          56
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          27,
                          37
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          -1,
                          46
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          63,
                          234
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          4,
                          61
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          6,
                          -14
                        ]
                      }
                    ],
                    "colName": 6,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          8,
                          59
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          15,
                          41
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          -5,
                          45
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          36,
                          149
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          6,
                          32
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -10,
                          -9
                        ]
                      }
                    ],
                    "colName": 7,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          6,
                          55
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          15,
                          23
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          6,
                          49
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          22,
                          152
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          -3,
                          36
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -1,
                          -9
                        ]
                      }
                    ],
                    "colName": 8,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          41
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          33
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          18
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          196
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          28
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -11
                        ]
                      }
                    ],
                    "colName": 9,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          29
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          28
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          19
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          52
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          9
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -2
                        ]
                      }
                    ],
                    "colName": 10,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          34
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          21
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          147
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          0
                        ]
                      }
                    ],
                    "colName": 11,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          32
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          17
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          13
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          141
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          41
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -20
                        ]
                      }
                    ],
                    "colName": 12,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 63,
                          "percent": null
                        },
                        "current": {
                          "value": 68,
                          "percent": 8
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 148,
                          "percent": null
                        },
                        "current": {
                          "value": 61,
                          "percent": -59
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 297,
                          "percent": null
                        },
                        "current": {
                          "value": 171,
                          "percent": -43
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 116,
                          "percent": null
                        },
                        "current": {
                          "value": 39,
                          "percent": -67
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 313,
                          "percent": null
                        },
                        "current": {
                          "value": 66,
                          "percent": -79
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 296,
                          "percent": null
                        },
                        "current": {
                          "value": 67,
                          "percent": -77
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 181,
                          "percent": null
                        },
                        "current": {
                          "value": 42,
                          "percent": -77
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 188,
                          "percent": null
                        },
                        "current": {
                          "value": 20,
                          "percent": -90
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 224,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 61,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 147,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 181,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 119,
                          "percent": null
                        },
                        "current": {
                          "value": 68,
                          "percent": -43
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 114,
                          "percent": null
                        },
                        "current": {
                          "value": 57,
                          "percent": -50
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 151,
                          "percent": null
                        },
                        "current": {
                          "value": 65,
                          "percent": -57
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 151,
                          "percent": null
                        },
                        "current": {
                          "value": 40,
                          "percent": -74
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 159,
                          "percent": null
                        },
                        "current": {
                          "value": 41,
                          "percent": -74
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 139,
                          "percent": null
                        },
                        "current": {
                          "value": 52,
                          "percent": -62
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 145,
                          "percent": null
                        },
                        "current": {
                          "value": 17,
                          "percent": -88
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 127,
                          "percent": null
                        },
                        "current": {
                          "value": 26,
                          "percent": -79
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 92,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 75,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 55,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 62,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 68,
                        "colName": 1,
                        "percent": 50,
                        "valueCompare": 63,
                        "percentCompare": 35
                      },
                      {
                        "title": "Specialties",
                        "value": 68,
                        "colName": 1,
                        "percent": 50,
                        "valueCompare": 119,
                        "percentCompare": 65
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 61,
                        "colName": 2,
                        "percent": 52,
                        "valueCompare": 148,
                        "percentCompare": 57
                      },
                      {
                        "title": "Specialties",
                        "value": 57,
                        "colName": 2,
                        "percent": 48,
                        "valueCompare": 114,
                        "percentCompare": 43
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 171,
                        "colName": 3,
                        "percent": 72,
                        "valueCompare": 297,
                        "percentCompare": 66
                      },
                      {
                        "title": "Specialties",
                        "value": 65,
                        "colName": 3,
                        "percent": 28,
                        "valueCompare": 151,
                        "percentCompare": 34
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 39,
                        "colName": 4,
                        "percent": 49,
                        "valueCompare": 116,
                        "percentCompare": 44
                      },
                      {
                        "title": "Specialties",
                        "value": 40,
                        "colName": 4,
                        "percent": 51,
                        "valueCompare": 151,
                        "percentCompare": 56
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 66,
                        "colName": 5,
                        "percent": 62,
                        "valueCompare": 313,
                        "percentCompare": 66
                      },
                      {
                        "title": "Specialties",
                        "value": 41,
                        "colName": 5,
                        "percent": 38,
                        "valueCompare": 159,
                        "percentCompare": 34
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 67,
                        "colName": 6,
                        "percent": 56,
                        "valueCompare": 296,
                        "percentCompare": 68
                      },
                      {
                        "title": "Specialties",
                        "value": 52,
                        "colName": 6,
                        "percent": 44,
                        "valueCompare": 139,
                        "percentCompare": 32
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 42,
                        "colName": 7,
                        "percent": 71,
                        "valueCompare": 181,
                        "percentCompare": 56
                      },
                      {
                        "title": "Specialties",
                        "value": 17,
                        "colName": 7,
                        "percent": 29,
                        "valueCompare": 145,
                        "percentCompare": 44
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 20,
                        "colName": 8,
                        "percent": 43,
                        "valueCompare": 188,
                        "percentCompare": 60
                      },
                      {
                        "title": "Specialties",
                        "value": 26,
                        "colName": 8,
                        "percent": 57,
                        "valueCompare": 127,
                        "percentCompare": 40
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 224,
                        "percentCompare": 71
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 92,
                        "percentCompare": 29
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 61,
                        "percentCompare": 45
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 75,
                        "percentCompare": 55
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 147,
                        "percentCompare": 73
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 55,
                        "percentCompare": 27
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 181,
                        "percentCompare": 74
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 62,
                        "percentCompare": 26
                      }
                    ],
                    "isCompare": true
                  }
                ],
                "isMainGraph": true
              },
              "title": "LY"
            },
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          31,
                          32
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          23,
                          17
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          14,
                          13
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          54,
                          141
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          14,
                          41
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -8,
                          -20
                        ]
                      }
                    ],
                    "colName": 1,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          32,
                          31
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          21,
                          23
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          4,
                          14
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          48,
                          54
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          13,
                          14
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -11,
                          -8
                        ]
                      }
                    ],
                    "colName": 2,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          27,
                          32
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          25,
                          21
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          14,
                          4
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          152,
                          48
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          19,
                          13
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          8,
                          -11
                        ]
                      }
                    ],
                    "colName": 3,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          14,
                          27
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          22,
                          25
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          4,
                          14
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          44,
                          152
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          -5,
                          19
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -8,
                          8
                        ]
                      }
                    ],
                    "colName": 4,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          19,
                          14
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          20,
                          22
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          2,
                          4
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          61,
                          44
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          5,
                          -5
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -5,
                          -8
                        ]
                      }
                    ],
                    "colName": 5,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          27,
                          19
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          27,
                          20
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          -1,
                          2
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          63,
                          61
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          4,
                          5
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          6,
                          -5
                        ]
                      }
                    ],
                    "colName": 6,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          8,
                          27
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          15,
                          27
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          -5,
                          -1
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          36,
                          63
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          6,
                          4
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -10,
                          6
                        ]
                      }
                    ],
                    "colName": 7,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          6,
                          8
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          15,
                          15
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          6,
                          -5
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          22,
                          36
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          -3,
                          6
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -1,
                          -10
                        ]
                      }
                    ],
                    "colName": 8,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          6
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          15
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          6
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          22
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          -3
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -1
                        ]
                      }
                    ],
                    "colName": 9,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          0
                        ]
                      }
                    ],
                    "colName": 10,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          0
                        ]
                      }
                    ],
                    "colName": 11,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          0
                        ]
                      }
                    ],
                    "colName": 12,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 68,
                          "percent": 29
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 61,
                          "percent": 24
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 171,
                          "percent": 42
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 39,
                          "percent": 20
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 66,
                          "percent": 26
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 67,
                          "percent": 20
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 42,
                          "percent": 17
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 20,
                          "percent": 8
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 68,
                          "percent": 15
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 57,
                          "percent": 13
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 65,
                          "percent": 14
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 40,
                          "percent": 11
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 41,
                          "percent": 10
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 52,
                          "percent": 13
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 17,
                          "percent": 4
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 26,
                          "percent": 6
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 68,
                        "colName": 1,
                        "percent": 50,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 68,
                        "colName": 1,
                        "percent": 50,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 61,
                        "colName": 2,
                        "percent": 52,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 57,
                        "colName": 2,
                        "percent": 48,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 171,
                        "colName": 3,
                        "percent": 72,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 65,
                        "colName": 3,
                        "percent": 28,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 39,
                        "colName": 4,
                        "percent": 49,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 40,
                        "colName": 4,
                        "percent": 51,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 66,
                        "colName": 5,
                        "percent": 62,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 41,
                        "colName": 5,
                        "percent": 38,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 67,
                        "colName": 6,
                        "percent": 56,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 52,
                        "colName": 6,
                        "percent": 44,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 42,
                        "colName": 7,
                        "percent": 71,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 17,
                        "colName": 7,
                        "percent": 29,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 20,
                        "colName": 8,
                        "percent": 43,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 26,
                        "colName": 8,
                        "percent": 57,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  }
                ],
                "isMainGraph": true
              },
              "title": ""
            },
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          31,
                          33
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          23,
                          19
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          14,
                          22
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          54,
                          83
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          14,
                          8
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -8,
                          -14
                        ]
                      }
                    ],
                    "colName": 1,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          32,
                          33
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          21,
                          20
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          4,
                          23
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          48,
                          82
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          13,
                          6
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -11,
                          -14
                        ]
                      }
                    ],
                    "colName": 2,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          27,
                          33
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          25,
                          19
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          14,
                          22
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          152,
                          83
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          19,
                          8
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          8,
                          -14
                        ]
                      }
                    ],
                    "colName": 3,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          14,
                          34
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          22,
                          21
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          4,
                          23
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          44,
                          80
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          -5,
                          6
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -8,
                          -13
                        ]
                      }
                    ],
                    "colName": 4,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          19,
                          34
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          20,
                          21
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          2,
                          24
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          61,
                          80
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          5,
                          6
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -5,
                          -14
                        ]
                      }
                    ],
                    "colName": 5,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          27,
                          35
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          27,
                          21
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          -1,
                          24
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          63,
                          81
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          4,
                          6
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          6,
                          -16
                        ]
                      }
                    ],
                    "colName": 6,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          8,
                          37
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          15,
                          22
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          -5,
                          25
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          36,
                          101
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          6,
                          6
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -10,
                          -13
                        ]
                      }
                    ],
                    "colName": 7,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          6,
                          38
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          15,
                          22
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          6,
                          25
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          22,
                          101
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          -3,
                          7
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -1,
                          -14
                        ]
                      }
                    ],
                    "colName": 8,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          37
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          22
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          26
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          101
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          7
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -15
                        ]
                      }
                    ],
                    "colName": 9,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          35
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          20
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          22
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          87
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          2
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -12
                        ]
                      }
                    ],
                    "colName": 10,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          36
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          20
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          22
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          88
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          1
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -14
                        ]
                      }
                    ],
                    "colName": 11,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          35
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          20
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          22
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          87
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          2
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -13
                        ]
                      }
                    ],
                    "colName": 12,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 91,
                          "percent": null
                        },
                        "current": {
                          "value": 68,
                          "percent": -25
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 88,
                          "percent": null
                        },
                        "current": {
                          "value": 61,
                          "percent": -31
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 91,
                          "percent": null
                        },
                        "current": {
                          "value": 171,
                          "percent": 87
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 86,
                          "percent": null
                        },
                        "current": {
                          "value": 39,
                          "percent": -55
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 86,
                          "percent": null
                        },
                        "current": {
                          "value": 66,
                          "percent": -24
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 87,
                          "percent": null
                        },
                        "current": {
                          "value": 67,
                          "percent": -23
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 107,
                          "percent": null
                        },
                        "current": {
                          "value": 42,
                          "percent": -60
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 108,
                          "percent": null
                        },
                        "current": {
                          "value": 20,
                          "percent": -82
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 108,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 89,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 89,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 89,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 74,
                          "percent": null
                        },
                        "current": {
                          "value": 68,
                          "percent": -9
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 76,
                          "percent": null
                        },
                        "current": {
                          "value": 57,
                          "percent": -25
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 74,
                          "percent": null
                        },
                        "current": {
                          "value": 65,
                          "percent": -12
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 78,
                          "percent": null
                        },
                        "current": {
                          "value": 40,
                          "percent": -49
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 79,
                          "percent": null
                        },
                        "current": {
                          "value": 41,
                          "percent": -48
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 80,
                          "percent": null
                        },
                        "current": {
                          "value": 52,
                          "percent": -34
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 84,
                          "percent": null
                        },
                        "current": {
                          "value": 17,
                          "percent": -79
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 85,
                          "percent": null
                        },
                        "current": {
                          "value": 26,
                          "percent": -69
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 85,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 77,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 78,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 77,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 68,
                        "colName": 1,
                        "percent": 50,
                        "valueCompare": 91,
                        "percentCompare": 55
                      },
                      {
                        "title": "Specialties",
                        "value": 68,
                        "colName": 1,
                        "percent": 50,
                        "valueCompare": 74,
                        "percentCompare": 45
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 61,
                        "colName": 2,
                        "percent": 52,
                        "valueCompare": 88,
                        "percentCompare": 54
                      },
                      {
                        "title": "Specialties",
                        "value": 57,
                        "colName": 2,
                        "percent": 48,
                        "valueCompare": 76,
                        "percentCompare": 46
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 171,
                        "colName": 3,
                        "percent": 72,
                        "valueCompare": 91,
                        "percentCompare": 55
                      },
                      {
                        "title": "Specialties",
                        "value": 65,
                        "colName": 3,
                        "percent": 28,
                        "valueCompare": 74,
                        "percentCompare": 45
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 39,
                        "colName": 4,
                        "percent": 49,
                        "valueCompare": 86,
                        "percentCompare": 52
                      },
                      {
                        "title": "Specialties",
                        "value": 40,
                        "colName": 4,
                        "percent": 51,
                        "valueCompare": 78,
                        "percentCompare": 48
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 66,
                        "colName": 5,
                        "percent": 62,
                        "valueCompare": 86,
                        "percentCompare": 52
                      },
                      {
                        "title": "Specialties",
                        "value": 41,
                        "colName": 5,
                        "percent": 38,
                        "valueCompare": 79,
                        "percentCompare": 48
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 67,
                        "colName": 6,
                        "percent": 56,
                        "valueCompare": 87,
                        "percentCompare": 52
                      },
                      {
                        "title": "Specialties",
                        "value": 52,
                        "colName": 6,
                        "percent": 44,
                        "valueCompare": 80,
                        "percentCompare": 48
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 42,
                        "colName": 7,
                        "percent": 71,
                        "valueCompare": 107,
                        "percentCompare": 56
                      },
                      {
                        "title": "Specialties",
                        "value": 17,
                        "colName": 7,
                        "percent": 29,
                        "valueCompare": 84,
                        "percentCompare": 44
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 20,
                        "colName": 8,
                        "percent": 43,
                        "valueCompare": 108,
                        "percentCompare": 56
                      },
                      {
                        "title": "Specialties",
                        "value": 26,
                        "colName": 8,
                        "percent": 57,
                        "valueCompare": 85,
                        "percentCompare": 44
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 108,
                        "percentCompare": 56
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 85,
                        "percentCompare": 44
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 89,
                        "percentCompare": 54
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 77,
                        "percentCompare": 46
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 89,
                        "percentCompare": 53
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 78,
                        "percentCompare": 47
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 89,
                        "percentCompare": 54
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 77,
                        "percentCompare": 46
                      }
                    ],
                    "isCompare": true
                  }
                ],
                "isMainGraph": true
              },
              "title": "BGT"
            }
          ]
        },
        "title": "OI"
      },
      {
        "data": {
          "qtd": [
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          105,
                          203
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          84,
                          115
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          45,
                          110
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          298,
                          450
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          86,
                          133
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -8,
                          -9
                        ]
                      }
                    ],
                    "colName": "Q1",
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          74,
                          206
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          83,
                          131
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          22,
                          155
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          213,
                          616
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          47,
                          183
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          2,
                          -33
                        ]
                      }
                    ],
                    "colName": "Q2",
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          24,
                          124
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          39,
                          72
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          12,
                          105
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          89,
                          329
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          31,
                          88
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -8,
                          -16
                        ]
                      }
                    ],
                    "colName": "",
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          170
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          110
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          127
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          537
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          129
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -24
                        ]
                      }
                    ],
                    "colName": "Q3",
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          110
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          80
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          56
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          385
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          85
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -18
                        ]
                      }
                    ],
                    "colName": "Q4",
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q1",
                        "compare": {
                          "value": 583,
                          "percent": null
                        },
                        "current": {
                          "value": 383,
                          "percent": -34
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q2",
                        "compare": {
                          "value": 799,
                          "percent": null
                        },
                        "current": {
                          "value": 260,
                          "percent": -67
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q3",
                        "compare": {
                          "value": 666,
                          "percent": null
                        },
                        "current": {
                          "value": 120,
                          "percent": -71
                        },
                        "partial": {
                          "value": 417,
                          "percent": null
                        },
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q4",
                        "compare": {
                          "value": 470,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q1",
                        "compare": {
                          "value": 428,
                          "percent": null
                        },
                        "current": {
                          "value": 234,
                          "percent": -45
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q2",
                        "compare": {
                          "value": 492,
                          "percent": null
                        },
                        "current": {
                          "value": 179,
                          "percent": -64
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q3",
                        "compare": {
                          "value": 407,
                          "percent": null
                        },
                        "current": {
                          "value": 75,
                          "percent": -75
                        },
                        "partial": {
                          "value": 301,
                          "percent": null
                        },
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q4",
                        "compare": {
                          "value": 246,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 383,
                        "colName": "Q1",
                        "percent": 62,
                        "valueCompare": 583,
                        "percentCompare": 58
                      },
                      {
                        "title": "Specialties",
                        "value": 234,
                        "colName": "Q1",
                        "percent": 38,
                        "valueCompare": 428,
                        "percentCompare": 42
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 260,
                        "colName": "Q2",
                        "percent": 59,
                        "valueCompare": 799,
                        "percentCompare": 62
                      },
                      {
                        "title": "Specialties",
                        "value": 179,
                        "colName": "Q2",
                        "percent": 41,
                        "valueCompare": 492,
                        "percentCompare": 38
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 120,
                        "colName": "",
                        "percent": 62,
                        "valueCompare": 417,
                        "percentCompare": 58
                      },
                      {
                        "title": "Specialties",
                        "value": 75,
                        "colName": "",
                        "percent": 38,
                        "valueCompare": 301,
                        "percentCompare": 42
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": "Q3",
                        "percent": 0,
                        "valueCompare": 666,
                        "percentCompare": 62
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": "Q3",
                        "percent": 0,
                        "valueCompare": 407,
                        "percentCompare": 38
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": "Q4",
                        "percent": 0,
                        "valueCompare": 470,
                        "percentCompare": 66
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": "Q4",
                        "percent": 0,
                        "valueCompare": 246,
                        "percentCompare": 34
                      }
                    ],
                    "isCompare": true
                  }
                ],
                "isMainGraph": true
              },
              "title": "LY"
            },
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          105,
                          110
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          84,
                          80
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          45,
                          56
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          298,
                          385
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          86,
                          85
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -8,
                          -18
                        ]
                      }
                    ],
                    "colName": "Q1",
                    "rowNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          74,
                          105
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          83,
                          84
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          22,
                          45
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          213,
                          298
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          47,
                          86
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          2,
                          -8
                        ]
                      }
                    ],
                    "colName": "Q2",
                    "rowNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          24,
                          43
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          39,
                          51
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          12,
                          17
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          89,
                          135
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          31,
                          30
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -8,
                          -9
                        ]
                      }
                    ],
                    "colName": "",
                    "rowNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          74
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          83
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          22
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          213
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          47
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          2
                        ]
                      }
                    ],
                    "colName": "Q3",
                    "rowNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          0
                        ]
                      }
                    ],
                    "colName": "Q4",
                    "rowNames": [
                      "ACT",
                      "LQ"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q1",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 383,
                          "percent": 43
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q2",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 260,
                          "percent": 33
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q3",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 120,
                          "percent": 24
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q4",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q1",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 234,
                          "percent": 17
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q2",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 179,
                          "percent": 15
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q3",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 75,
                          "percent": 9
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q4",
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 383,
                        "colName": "Q1",
                        "percent": 62,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 234,
                        "colName": "Q1",
                        "percent": 38,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 260,
                        "colName": "Q2",
                        "percent": 59,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 179,
                        "colName": "Q2",
                        "percent": 41,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 120,
                        "colName": "",
                        "percent": 62,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 75,
                        "colName": "",
                        "percent": 38,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": "Q3",
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": "Q3",
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": "Q4",
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": "Q4",
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  }
                ],
                "isMainGraph": true
              },
              "title": ""
            },
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          105,
                          114
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          84,
                          72
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          45,
                          83
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          298,
                          291
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          86,
                          59
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -8,
                          -37
                        ]
                      }
                    ],
                    "colName": "Q1",
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          74,
                          119
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          83,
                          76
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          22,
                          87
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          213,
                          288
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          47,
                          56
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          2,
                          -41
                        ]
                      }
                    ],
                    "colName": "Q2",
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          24,
                          85
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          39,
                          54
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          12,
                          62
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          89,
                          234
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          31,
                          37
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -8,
                          -26
                        ]
                      }
                    ],
                    "colName": "",
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          128
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          80
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          93
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          351
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          57
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -40
                        ]
                      }
                    ],
                    "colName": "Q3",
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          122
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          74
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          82
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          308
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          42
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -36
                        ]
                      }
                    ],
                    "colName": "Q4",
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q1",
                        "compare": {
                          "value": 350,
                          "percent": null
                        },
                        "current": {
                          "value": 383,
                          "percent": 10
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q2",
                        "compare": {
                          "value": 344,
                          "percent": null
                        },
                        "current": {
                          "value": 260,
                          "percent": -24
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q3",
                        "compare": {
                          "value": 408,
                          "percent": null
                        },
                        "current": {
                          "value": 120,
                          "percent": -56
                        },
                        "partial": {
                          "value": 271,
                          "percent": null
                        },
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q4",
                        "compare": {
                          "value": 350,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q1",
                        "compare": {
                          "value": 269,
                          "percent": null
                        },
                        "current": {
                          "value": 234,
                          "percent": -13
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q2",
                        "compare": {
                          "value": 282,
                          "percent": null
                        },
                        "current": {
                          "value": 179,
                          "percent": -36
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q3",
                        "compare": {
                          "value": 301,
                          "percent": null
                        },
                        "current": {
                          "value": 75,
                          "percent": -63
                        },
                        "partial": {
                          "value": 201,
                          "percent": null
                        },
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": "Q4",
                        "compare": {
                          "value": 278,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 383,
                        "colName": "Q1",
                        "percent": 62,
                        "valueCompare": 350,
                        "percentCompare": 57
                      },
                      {
                        "title": "Specialties",
                        "value": 234,
                        "colName": "Q1",
                        "percent": 38,
                        "valueCompare": 269,
                        "percentCompare": 43
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 260,
                        "colName": "Q2",
                        "percent": 59,
                        "valueCompare": 344,
                        "percentCompare": 55
                      },
                      {
                        "title": "Specialties",
                        "value": 179,
                        "colName": "Q2",
                        "percent": 41,
                        "valueCompare": 282,
                        "percentCompare": 45
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 120,
                        "colName": "",
                        "percent": 62,
                        "valueCompare": 271,
                        "percentCompare": 57
                      },
                      {
                        "title": "Specialties",
                        "value": 75,
                        "colName": "",
                        "percent": 38,
                        "valueCompare": 201,
                        "percentCompare": 43
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": "Q3",
                        "percent": 0,
                        "valueCompare": 408,
                        "percentCompare": 58
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": "Q3",
                        "percent": 0,
                        "valueCompare": 301,
                        "percentCompare": 42
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": "Q4",
                        "percent": 0,
                        "valueCompare": 350,
                        "percentCompare": 56
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": "Q4",
                        "percent": 0,
                        "valueCompare": 278,
                        "percentCompare": 44
                      }
                    ],
                    "isCompare": true
                  }
                ],
                "isMainGraph": true
              },
              "title": "BGT"
            }
          ],
          "ytd": [
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          36,
                          66
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          28,
                          40
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          15,
                          27
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          69,
                          58
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          27,
                          32
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -7,
                          -12
                        ]
                      }
                    ],
                    "colName": 1,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          73,
                          130
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          53,
                          72
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          25,
                          59
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          130,
                          194
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          54,
                          67
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -16,
                          -10
                        ]
                      }
                    ],
                    "colName": 2,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          105,
                          203
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          84,
                          115
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          45,
                          110
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          298,
                          450
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          86,
                          133
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -8,
                          -9
                        ]
                      }
                    ],
                    "colName": 3,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          123,
                          277
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          110,
                          161
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          55,
                          156
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          357,
                          543
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          96,
                          179
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -12,
                          -16
                        ]
                      }
                    ],
                    "colName": 4,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          147,
                          349
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          135,
                          204
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          62,
                          215
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          433,
                          818
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          116,
                          243
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -15,
                          -27
                        ]
                      }
                    ],
                    "colName": 5,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          179,
                          409
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          167,
                          246
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          67,
                          265
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          511,
                          1066
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          133,
                          316
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -6,
                          -42
                        ]
                      }
                    ],
                    "colName": 6,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          191,
                          473
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          187,
                          291
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          68,
                          315
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          563,
                          1228
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          153,
                          358
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -15,
                          -49
                        ]
                      }
                    ],
                    "colName": 7,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          202,
                          533
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          206,
                          319
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          79,
                          369
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          601,
                          1394
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          163,
                          404
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -13,
                          -57
                        ]
                      }
                    ],
                    "colName": 8,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          579
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          357
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          392
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          1603
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          445
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -67
                        ]
                      }
                    ],
                    "colName": 9,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          613
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          389
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          416
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          1670
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          464
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -67
                        ]
                      }
                    ],
                    "colName": 10,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          652
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          415
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          421
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          1832
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          475
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -68
                        ]
                      }
                    ],
                    "colName": 11,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          689
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          436
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          448
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          1988
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          529
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -83
                        ]
                      }
                    ],
                    "colName": 12,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 89,
                          "percent": null
                        },
                        "current": {
                          "value": 96,
                          "percent": 7
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 260,
                          "percent": null
                        },
                        "current": {
                          "value": 185,
                          "percent": -29
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 583,
                          "percent": null
                        },
                        "current": {
                          "value": 383,
                          "percent": -34
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 722,
                          "percent": null
                        },
                        "current": {
                          "value": 452,
                          "percent": -37
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 1061,
                          "percent": null
                        },
                        "current": {
                          "value": 549,
                          "percent": -48
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 1382,
                          "percent": null
                        },
                        "current": {
                          "value": 643,
                          "percent": -53
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 1586,
                          "percent": null
                        },
                        "current": {
                          "value": 716,
                          "percent": -55
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 1798,
                          "percent": null
                        },
                        "current": {
                          "value": 764,
                          "percent": -58
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 2047,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 2134,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 2307,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 2517,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 133,
                          "percent": null
                        },
                        "current": {
                          "value": 79,
                          "percent": -41
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 262,
                          "percent": null
                        },
                        "current": {
                          "value": 151,
                          "percent": -42
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 428,
                          "percent": null
                        },
                        "current": {
                          "value": 234,
                          "percent": -45
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 594,
                          "percent": null
                        },
                        "current": {
                          "value": 288,
                          "percent": -51
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 768,
                          "percent": null
                        },
                        "current": {
                          "value": 344,
                          "percent": -55
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 920,
                          "percent": null
                        },
                        "current": {
                          "value": 413,
                          "percent": -55
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 1079,
                          "percent": null
                        },
                        "current": {
                          "value": 446,
                          "percent": -59
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 1221,
                          "percent": null
                        },
                        "current": {
                          "value": 488,
                          "percent": -60
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 1328,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 1418,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 1487,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 1573,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 96,
                        "colName": 1,
                        "percent": 55,
                        "valueCompare": 89,
                        "percentCompare": 40
                      },
                      {
                        "title": "Specialties",
                        "value": 79,
                        "colName": 1,
                        "percent": 45,
                        "valueCompare": 133,
                        "percentCompare": 60
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 185,
                        "colName": 2,
                        "percent": 55,
                        "valueCompare": 260,
                        "percentCompare": 50
                      },
                      {
                        "title": "Specialties",
                        "value": 151,
                        "colName": 2,
                        "percent": 45,
                        "valueCompare": 262,
                        "percentCompare": 50
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 383,
                        "colName": 3,
                        "percent": 62,
                        "valueCompare": 583,
                        "percentCompare": 58
                      },
                      {
                        "title": "Specialties",
                        "value": 234,
                        "colName": 3,
                        "percent": 38,
                        "valueCompare": 428,
                        "percentCompare": 42
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 452,
                        "colName": 4,
                        "percent": 61,
                        "valueCompare": 722,
                        "percentCompare": 55
                      },
                      {
                        "title": "Specialties",
                        "value": 288,
                        "colName": 4,
                        "percent": 39,
                        "valueCompare": 594,
                        "percentCompare": 45
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 549,
                        "colName": 5,
                        "percent": 61,
                        "valueCompare": 1061,
                        "percentCompare": 58
                      },
                      {
                        "title": "Specialties",
                        "value": 344,
                        "colName": 5,
                        "percent": 39,
                        "valueCompare": 768,
                        "percentCompare": 42
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 643,
                        "colName": 6,
                        "percent": 61,
                        "valueCompare": 1382,
                        "percentCompare": 60
                      },
                      {
                        "title": "Specialties",
                        "value": 413,
                        "colName": 6,
                        "percent": 39,
                        "valueCompare": 920,
                        "percentCompare": 40
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 716,
                        "colName": 7,
                        "percent": 62,
                        "valueCompare": 1586,
                        "percentCompare": 60
                      },
                      {
                        "title": "Specialties",
                        "value": 446,
                        "colName": 7,
                        "percent": 38,
                        "valueCompare": 1079,
                        "percentCompare": 40
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 764,
                        "colName": 8,
                        "percent": 61,
                        "valueCompare": 1798,
                        "percentCompare": 60
                      },
                      {
                        "title": "Specialties",
                        "value": 488,
                        "colName": 8,
                        "percent": 39,
                        "valueCompare": 1221,
                        "percentCompare": 40
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 2047,
                        "percentCompare": 61
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 1328,
                        "percentCompare": 39
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 2134,
                        "percentCompare": 60
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 1418,
                        "percentCompare": 40
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 2307,
                        "percentCompare": 61
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 1487,
                        "percentCompare": 39
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 2517,
                        "percentCompare": 62
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 1573,
                        "percentCompare": 38
                      }
                    ],
                    "isCompare": true
                  }
                ],
                "isMainGraph": true
              },
              "title": "LY"
            },
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          36
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          28
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          15
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          69
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          27
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -7
                        ]
                      }
                    ],
                    "colName": 1,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          73
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          53
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          25
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          130
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          54
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -16
                        ]
                      }
                    ],
                    "colName": 2,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          105
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          84
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          45
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          298
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          86
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -8
                        ]
                      }
                    ],
                    "colName": 3,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          123
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          110
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          55
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          357
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          96
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -12
                        ]
                      }
                    ],
                    "colName": 4,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          147
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          135
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          62
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          433
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          116
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -15
                        ]
                      }
                    ],
                    "colName": 5,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          179
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          167
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          67
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          511
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          133
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -6
                        ]
                      }
                    ],
                    "colName": 6,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          191
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          187
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          68
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          563
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          153
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -15
                        ]
                      }
                    ],
                    "colName": 7,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          202
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          206
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          79
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          601
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          163
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -13
                        ]
                      }
                    ],
                    "colName": 8,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0
                        ]
                      }
                    ],
                    "colName": 9,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0
                        ]
                      }
                    ],
                    "colName": 10,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0
                        ]
                      }
                    ],
                    "colName": 11,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0
                        ]
                      }
                    ],
                    "colName": 12,
                    "rowNames": [
                      "ACT",
                      null
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 96,
                          "percent": 41
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 185,
                          "percent": 38
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 383,
                          "percent": 43
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 452,
                          "percent": 42
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 549,
                          "percent": 41
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 643,
                          "percent": 38
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 716,
                          "percent": 38
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 764,
                          "percent": 36
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 79,
                          "percent": 18
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 151,
                          "percent": 17
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 234,
                          "percent": 17
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 288,
                          "percent": 17
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 344,
                          "percent": 16
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 413,
                          "percent": 16
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 446,
                          "percent": 15
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 488,
                          "percent": 15
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 96,
                        "colName": 1,
                        "percent": 55,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 79,
                        "colName": 1,
                        "percent": 45,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 185,
                        "colName": 2,
                        "percent": 55,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 151,
                        "colName": 2,
                        "percent": 45,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 383,
                        "colName": 3,
                        "percent": 62,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 234,
                        "colName": 3,
                        "percent": 38,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 452,
                        "colName": 4,
                        "percent": 61,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 288,
                        "colName": 4,
                        "percent": 39,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 549,
                        "colName": 5,
                        "percent": 61,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 344,
                        "colName": 5,
                        "percent": 39,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 643,
                        "colName": 6,
                        "percent": 61,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 413,
                        "colName": 6,
                        "percent": 39,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 716,
                        "colName": 7,
                        "percent": 62,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 446,
                        "colName": 7,
                        "percent": 38,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 764,
                        "colName": 8,
                        "percent": 61,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 488,
                        "colName": 8,
                        "percent": 39,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  }
                ],
                "isMainGraph": true
              },
              "title": ""
            },
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          36,
                          38
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          28,
                          24
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          15,
                          28
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          69,
                          97
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          27,
                          20
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -7,
                          -13
                        ]
                      }
                    ],
                    "colName": 1,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          73,
                          76
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          53,
                          48
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          25,
                          56
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          130,
                          194
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          54,
                          39
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -16,
                          -25
                        ]
                      }
                    ],
                    "colName": 2,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          105,
                          114
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          84,
                          72
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          45,
                          83
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          298,
                          291
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          86,
                          59
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -8,
                          -37
                        ]
                      }
                    ],
                    "colName": 3,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          123,
                          154
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          110,
                          97
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          55,
                          112
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          357,
                          387
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          96,
                          78
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -12,
                          -51
                        ]
                      }
                    ],
                    "colName": 4,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          147,
                          194
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          135,
                          123
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          62,
                          141
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          433,
                          483
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          116,
                          96
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -15,
                          -65
                        ]
                      }
                    ],
                    "colName": 5,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          179,
                          233
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          167,
                          148
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          67,
                          170
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          511,
                          579
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          133,
                          115
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -6,
                          -78
                        ]
                      }
                    ],
                    "colName": 6,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          191,
                          276
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          187,
                          175
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          68,
                          201
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          563,
                          696
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          153,
                          133
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -15,
                          -91
                        ]
                      }
                    ],
                    "colName": 7,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          202,
                          318
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          206,
                          202
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          79,
                          232
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          601,
                          813
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          163,
                          152
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -13,
                          -104
                        ]
                      }
                    ],
                    "colName": 8,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          361
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          228
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          263
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          930
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          172
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -118
                        ]
                      }
                    ],
                    "colName": 9,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          402
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          253
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          291
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          1033
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          186
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -131
                        ]
                      }
                    ],
                    "colName": 10,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          443
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          277
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          318
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          1135
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          201
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -143
                        ]
                      }
                    ],
                    "colName": 11,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          483
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          302
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          345
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          1238
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          214
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -154
                        ]
                      }
                    ],
                    "colName": 12,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 117,
                          "percent": null
                        },
                        "current": {
                          "value": 96,
                          "percent": -18
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 233,
                          "percent": null
                        },
                        "current": {
                          "value": 185,
                          "percent": -21
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 350,
                          "percent": null
                        },
                        "current": {
                          "value": 383,
                          "percent": 10
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 465,
                          "percent": null
                        },
                        "current": {
                          "value": 452,
                          "percent": -3
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 579,
                          "percent": null
                        },
                        "current": {
                          "value": 549,
                          "percent": -5
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 694,
                          "percent": null
                        },
                        "current": {
                          "value": 643,
                          "percent": -7
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 829,
                          "percent": null
                        },
                        "current": {
                          "value": 716,
                          "percent": -14
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 965,
                          "percent": null
                        },
                        "current": {
                          "value": 764,
                          "percent": -21
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 1102,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 1219,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 1336,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 1452,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 90,
                          "percent": null
                        },
                        "current": {
                          "value": 79,
                          "percent": -12
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 180,
                          "percent": null
                        },
                        "current": {
                          "value": 151,
                          "percent": -16
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 269,
                          "percent": null
                        },
                        "current": {
                          "value": 234,
                          "percent": -13
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 363,
                          "percent": null
                        },
                        "current": {
                          "value": 288,
                          "percent": -21
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 458,
                          "percent": null
                        },
                        "current": {
                          "value": 344,
                          "percent": -25
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 551,
                          "percent": null
                        },
                        "current": {
                          "value": 413,
                          "percent": -25
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 652,
                          "percent": null
                        },
                        "current": {
                          "value": 446,
                          "percent": -32
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 752,
                          "percent": null
                        },
                        "current": {
                          "value": 488,
                          "percent": -35
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 852,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 946,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 1038,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 1130,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 96,
                        "colName": 1,
                        "percent": 55,
                        "valueCompare": 117,
                        "percentCompare": 57
                      },
                      {
                        "title": "Specialties",
                        "value": 79,
                        "colName": 1,
                        "percent": 45,
                        "valueCompare": 90,
                        "percentCompare": 43
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 185,
                        "colName": 2,
                        "percent": 55,
                        "valueCompare": 233,
                        "percentCompare": 56
                      },
                      {
                        "title": "Specialties",
                        "value": 151,
                        "colName": 2,
                        "percent": 45,
                        "valueCompare": 180,
                        "percentCompare": 44
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 383,
                        "colName": 3,
                        "percent": 62,
                        "valueCompare": 350,
                        "percentCompare": 57
                      },
                      {
                        "title": "Specialties",
                        "value": 234,
                        "colName": 3,
                        "percent": 38,
                        "valueCompare": 269,
                        "percentCompare": 43
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 452,
                        "colName": 4,
                        "percent": 61,
                        "valueCompare": 465,
                        "percentCompare": 56
                      },
                      {
                        "title": "Specialties",
                        "value": 288,
                        "colName": 4,
                        "percent": 39,
                        "valueCompare": 363,
                        "percentCompare": 44
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 549,
                        "colName": 5,
                        "percent": 61,
                        "valueCompare": 579,
                        "percentCompare": 56
                      },
                      {
                        "title": "Specialties",
                        "value": 344,
                        "colName": 5,
                        "percent": 39,
                        "valueCompare": 458,
                        "percentCompare": 44
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 643,
                        "colName": 6,
                        "percent": 61,
                        "valueCompare": 694,
                        "percentCompare": 56
                      },
                      {
                        "title": "Specialties",
                        "value": 413,
                        "colName": 6,
                        "percent": 39,
                        "valueCompare": 551,
                        "percentCompare": 44
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 716,
                        "colName": 7,
                        "percent": 62,
                        "valueCompare": 829,
                        "percentCompare": 56
                      },
                      {
                        "title": "Specialties",
                        "value": 446,
                        "colName": 7,
                        "percent": 38,
                        "valueCompare": 652,
                        "percentCompare": 44
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 764,
                        "colName": 8,
                        "percent": 61,
                        "valueCompare": 965,
                        "percentCompare": 56
                      },
                      {
                        "title": "Specialties",
                        "value": 488,
                        "colName": 8,
                        "percent": 39,
                        "valueCompare": 752,
                        "percentCompare": 44
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 1102,
                        "percentCompare": 56
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 852,
                        "percentCompare": 44
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 1219,
                        "percentCompare": 56
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 946,
                        "percentCompare": 44
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 1336,
                        "percentCompare": 56
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 1038,
                        "percentCompare": 44
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 1452,
                        "percentCompare": 56
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 1130,
                        "percentCompare": 44
                      }
                    ],
                    "isCompare": true
                  }
                ],
                "isMainGraph": true
              },
              "title": "BGT"
            }
          ],
          "month": [
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          36,
                          66
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          28,
                          40
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          15,
                          27
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          69,
                          58
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          27,
                          32
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -7,
                          -12
                        ]
                      }
                    ],
                    "colName": 1,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          37,
                          64
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          25,
                          33
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          9,
                          32
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          62,
                          136
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          27,
                          35
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -9,
                          1
                        ]
                      }
                    ],
                    "colName": 2,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          31,
                          73
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          31,
                          43
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          20,
                          50
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          167,
                          257
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          31,
                          66
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          12,
                          1
                        ]
                      }
                    ],
                    "colName": 3,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          19,
                          73
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          27,
                          46
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          10,
                          47
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          59,
                          93
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          10,
                          47
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -7,
                          -7
                        ]
                      }
                    ],
                    "colName": 4,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          24,
                          72
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          24,
                          43
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          8,
                          59
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          76,
                          275
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          20,
                          64
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -3,
                          -12
                        ]
                      }
                    ],
                    "colName": 5,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          32,
                          61
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          33,
                          42
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          5,
                          49
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          79,
                          247
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          17,
                          72
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          7,
                          -13
                        ]
                      }
                    ],
                    "colName": 6,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          13,
                          64
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          20,
                          45
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          1,
                          50
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          51,
                          162
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          20,
                          42
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -9,
                          -7
                        ]
                      }
                    ],
                    "colName": 7,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          11,
                          60
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          19,
                          27
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          12,
                          55
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          38,
                          167
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          11,
                          46
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -9
                        ]
                      }
                    ],
                    "colName": 8,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          46
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          38
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          23
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          209
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          41
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -10
                        ]
                      }
                    ],
                    "colName": 9,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          34
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          33
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          24
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          67
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          19
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -1
                        ]
                      }
                    ],
                    "colName": 10,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          39
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          26
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          5
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          162
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          11
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          0
                        ]
                      }
                    ],
                    "colName": 11,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          37
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          22
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          27
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          156
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          54
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -18
                        ]
                      }
                    ],
                    "colName": 12,
                    "rowNames": [
                      "ACT",
                      "LY"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 89,
                          "percent": null
                        },
                        "current": {
                          "value": 96,
                          "percent": 7
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 171,
                          "percent": null
                        },
                        "current": {
                          "value": 89,
                          "percent": -48
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 323,
                          "percent": null
                        },
                        "current": {
                          "value": 199,
                          "percent": -38
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 139,
                          "percent": null
                        },
                        "current": {
                          "value": 69,
                          "percent": -51
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 339,
                          "percent": null
                        },
                        "current": {
                          "value": 96,
                          "percent": -72
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 320,
                          "percent": null
                        },
                        "current": {
                          "value": 96,
                          "percent": -70
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 205,
                          "percent": null
                        },
                        "current": {
                          "value": 71,
                          "percent": -65
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 213,
                          "percent": null
                        },
                        "current": {
                          "value": 49,
                          "percent": -77
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 250,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 86,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 173,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 210,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 133,
                          "percent": null
                        },
                        "current": {
                          "value": 79,
                          "percent": -41
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 129,
                          "percent": null
                        },
                        "current": {
                          "value": 72,
                          "percent": -44
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 167,
                          "percent": null
                        },
                        "current": {
                          "value": 82,
                          "percent": -51
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 165,
                          "percent": null
                        },
                        "current": {
                          "value": 55,
                          "percent": -67
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 174,
                          "percent": null
                        },
                        "current": {
                          "value": 56,
                          "percent": -68
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 153,
                          "percent": null
                        },
                        "current": {
                          "value": 69,
                          "percent": -55
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 159,
                          "percent": null
                        },
                        "current": {
                          "value": 33,
                          "percent": -79
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 142,
                          "percent": null
                        },
                        "current": {
                          "value": 42,
                          "percent": -70
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 107,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 90,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 69,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 86,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 96,
                        "colName": 1,
                        "percent": 55,
                        "valueCompare": 89,
                        "percentCompare": 40
                      },
                      {
                        "title": "Specialties",
                        "value": 79,
                        "colName": 1,
                        "percent": 45,
                        "valueCompare": 133,
                        "percentCompare": 60
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 89,
                        "colName": 2,
                        "percent": 55,
                        "valueCompare": 171,
                        "percentCompare": 57
                      },
                      {
                        "title": "Specialties",
                        "value": 72,
                        "colName": 2,
                        "percent": 45,
                        "valueCompare": 129,
                        "percentCompare": 43
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 199,
                        "colName": 3,
                        "percent": 71,
                        "valueCompare": 323,
                        "percentCompare": 66
                      },
                      {
                        "title": "Specialties",
                        "value": 82,
                        "colName": 3,
                        "percent": 29,
                        "valueCompare": 167,
                        "percentCompare": 34
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 69,
                        "colName": 4,
                        "percent": 56,
                        "valueCompare": 139,
                        "percentCompare": 46
                      },
                      {
                        "title": "Specialties",
                        "value": 55,
                        "colName": 4,
                        "percent": 44,
                        "valueCompare": 165,
                        "percentCompare": 54
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 96,
                        "colName": 5,
                        "percent": 63,
                        "valueCompare": 339,
                        "percentCompare": 66
                      },
                      {
                        "title": "Specialties",
                        "value": 56,
                        "colName": 5,
                        "percent": 37,
                        "valueCompare": 174,
                        "percentCompare": 34
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 96,
                        "colName": 6,
                        "percent": 58,
                        "valueCompare": 320,
                        "percentCompare": 68
                      },
                      {
                        "title": "Specialties",
                        "value": 69,
                        "colName": 6,
                        "percent": 42,
                        "valueCompare": 153,
                        "percentCompare": 32
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 71,
                        "colName": 7,
                        "percent": 68,
                        "valueCompare": 205,
                        "percentCompare": 56
                      },
                      {
                        "title": "Specialties",
                        "value": 33,
                        "colName": 7,
                        "percent": 32,
                        "valueCompare": 159,
                        "percentCompare": 44
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 49,
                        "colName": 8,
                        "percent": 54,
                        "valueCompare": 213,
                        "percentCompare": 60
                      },
                      {
                        "title": "Specialties",
                        "value": 42,
                        "colName": 8,
                        "percent": 46,
                        "valueCompare": 142,
                        "percentCompare": 40
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 250,
                        "percentCompare": 70
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 107,
                        "percentCompare": 30
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 86,
                        "percentCompare": 49
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 90,
                        "percentCompare": 51
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 173,
                        "percentCompare": 71
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 69,
                        "percentCompare": 29
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 210,
                        "percentCompare": 71
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 86,
                        "percentCompare": 29
                      }
                    ],
                    "isCompare": true
                  }
                ],
                "isMainGraph": true
              },
              "title": "LY"
            },
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          36,
                          37
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          28,
                          22
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          15,
                          27
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          69,
                          156
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          27,
                          54
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -7,
                          -18
                        ]
                      }
                    ],
                    "colName": 1,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          37,
                          36
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          25,
                          28
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          9,
                          15
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          62,
                          69
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          27,
                          27
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -9,
                          -7
                        ]
                      }
                    ],
                    "colName": 2,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          31,
                          37
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          31,
                          25
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          20,
                          9
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          167,
                          62
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          31,
                          27
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          12,
                          -9
                        ]
                      }
                    ],
                    "colName": 3,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          19,
                          31
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          27,
                          31
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          10,
                          20
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          59,
                          167
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          10,
                          31
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -7,
                          12
                        ]
                      }
                    ],
                    "colName": 4,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          24,
                          19
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          24,
                          27
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          8,
                          10
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          76,
                          59
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          20,
                          10
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -3,
                          -7
                        ]
                      }
                    ],
                    "colName": 5,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          32,
                          24
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          33,
                          24
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          5,
                          8
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          79,
                          76
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          17,
                          20
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          7,
                          -3
                        ]
                      }
                    ],
                    "colName": 6,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          13,
                          32
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          20,
                          33
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          1,
                          5
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          51,
                          79
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          20,
                          17
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -9,
                          7
                        ]
                      }
                    ],
                    "colName": 7,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          11,
                          13
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          19,
                          20
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          12,
                          1
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          38,
                          51
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          11,
                          20
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -9
                        ]
                      }
                    ],
                    "colName": 8,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          11
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          19
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          12
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          38
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          11
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          0
                        ]
                      }
                    ],
                    "colName": 9,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          0
                        ]
                      }
                    ],
                    "colName": 10,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          0
                        ]
                      }
                    ],
                    "colName": 11,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          0
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          0
                        ]
                      }
                    ],
                    "colName": 12,
                    "rowNames": [
                      "ACT",
                      "LM"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 96,
                          "percent": 41
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 89,
                          "percent": 35
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 199,
                          "percent": 49
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 69,
                          "percent": 35
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 96,
                          "percent": 37
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 96,
                          "percent": 28
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 71,
                          "percent": 29
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 49,
                          "percent": 20
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 79,
                          "percent": 18
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 72,
                          "percent": 17
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 82,
                          "percent": 17
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 55,
                          "percent": 15
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 56,
                          "percent": 14
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 69,
                          "percent": 18
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 33,
                          "percent": 8
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": 42,
                          "percent": 10
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": null,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 96,
                        "colName": 1,
                        "percent": 55,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 79,
                        "colName": 1,
                        "percent": 45,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 89,
                        "colName": 2,
                        "percent": 55,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 72,
                        "colName": 2,
                        "percent": 45,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 199,
                        "colName": 3,
                        "percent": 71,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 82,
                        "colName": 3,
                        "percent": 29,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 69,
                        "colName": 4,
                        "percent": 56,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 55,
                        "colName": 4,
                        "percent": 44,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 96,
                        "colName": 5,
                        "percent": 63,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 56,
                        "colName": 5,
                        "percent": 37,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 96,
                        "colName": 6,
                        "percent": 58,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 69,
                        "colName": 6,
                        "percent": 42,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 71,
                        "colName": 7,
                        "percent": 68,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 33,
                        "colName": 7,
                        "percent": 32,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 49,
                        "colName": 8,
                        "percent": 54,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 42,
                        "colName": 8,
                        "percent": 46,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": null,
                        "percentCompare": null
                      }
                    ],
                    "isCompare": false
                  }
                ],
                "isMainGraph": true
              },
              "title": ""
            },
            {
              "graph": {
                "data": null,
                "blocks": [
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          36,
                          38
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          28,
                          24
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          15,
                          28
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          69,
                          97
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          27,
                          20
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -7,
                          -13
                        ]
                      }
                    ],
                    "colName": 1,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          37,
                          38
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          25,
                          24
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          9,
                          28
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          62,
                          97
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          27,
                          19
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -9,
                          -12
                        ]
                      }
                    ],
                    "colName": 2,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          31,
                          38
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          31,
                          24
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          20,
                          27
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          167,
                          97
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          31,
                          20
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          12,
                          -12
                        ]
                      }
                    ],
                    "colName": 3,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          19,
                          40
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          27,
                          25
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          10,
                          29
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          59,
                          96
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          10,
                          19
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -7,
                          -14
                        ]
                      }
                    ],
                    "colName": 4,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          24,
                          40
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          24,
                          26
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          8,
                          29
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          76,
                          96
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          20,
                          18
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -3,
                          -14
                        ]
                      }
                    ],
                    "colName": 5,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          32,
                          39
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          33,
                          25
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          5,
                          29
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          79,
                          96
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          17,
                          19
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          7,
                          -13
                        ]
                      }
                    ],
                    "colName": 6,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          13,
                          43
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          20,
                          27
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          1,
                          31
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          51,
                          117
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          20,
                          18
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          -9,
                          -13
                        ]
                      }
                    ],
                    "colName": 7,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          11,
                          42
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          19,
                          27
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          12,
                          31
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          38,
                          117
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          11,
                          19
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -13
                        ]
                      }
                    ],
                    "colName": 8,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          43
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          26
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          31
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          117
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          20
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -14
                        ]
                      }
                    ],
                    "colName": 9,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          41
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          25
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          28
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          103
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          14
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -13
                        ]
                      }
                    ],
                    "colName": 10,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          41
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          24
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          27
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          102
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          15
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -12
                        ]
                      }
                    ],
                    "colName": 11,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "blocks": [
                      {
                        "type": "specialties",
                        "title": "IP",
                        "fields": [
                          0,
                          40
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "PS-S",
                        "fields": [
                          0,
                          25
                        ]
                      },
                      {
                        "type": "specialties",
                        "title": "GS",
                        "fields": [
                          0,
                          27
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "Potash",
                        "fields": [
                          0,
                          103
                        ]
                      },
                      {
                        "type": "commodities",
                        "title": "PS-C",
                        "fields": [
                          0,
                          13
                        ]
                      },
                      {
                        "type": "other",
                        "title": "Other",
                        "fields": [
                          0,
                          -11
                        ]
                      }
                    ],
                    "colName": 12,
                    "rowNames": [
                      "ACT",
                      "BGT"
                    ]
                  }
                ],
                "graphs": [
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 117,
                          "percent": null
                        },
                        "current": {
                          "value": 96,
                          "percent": -18
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 116,
                          "percent": null
                        },
                        "current": {
                          "value": 89,
                          "percent": -24
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 117,
                          "percent": null
                        },
                        "current": {
                          "value": 199,
                          "percent": 70
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 115,
                          "percent": null
                        },
                        "current": {
                          "value": 69,
                          "percent": -40
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 114,
                          "percent": null
                        },
                        "current": {
                          "value": 96,
                          "percent": -16
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 115,
                          "percent": null
                        },
                        "current": {
                          "value": 96,
                          "percent": -17
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 135,
                          "percent": null
                        },
                        "current": {
                          "value": 71,
                          "percent": -47
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 136,
                          "percent": null
                        },
                        "current": {
                          "value": 49,
                          "percent": -64
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 137,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 117,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 117,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 116,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  },
                  {
                    "data": [
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 1,
                        "compare": {
                          "value": 90,
                          "percent": null
                        },
                        "current": {
                          "value": 79,
                          "percent": -12
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 2,
                        "compare": {
                          "value": 90,
                          "percent": null
                        },
                        "current": {
                          "value": 72,
                          "percent": -20
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 3,
                        "compare": {
                          "value": 89,
                          "percent": null
                        },
                        "current": {
                          "value": 82,
                          "percent": -8
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 4,
                        "compare": {
                          "value": 94,
                          "percent": null
                        },
                        "current": {
                          "value": 55,
                          "percent": -41
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 5,
                        "compare": {
                          "value": 95,
                          "percent": null
                        },
                        "current": {
                          "value": 56,
                          "percent": -41
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 6,
                        "compare": {
                          "value": 93,
                          "percent": null
                        },
                        "current": {
                          "value": 69,
                          "percent": -26
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 7,
                        "compare": {
                          "value": 101,
                          "percent": null
                        },
                        "current": {
                          "value": 33,
                          "percent": -67
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 8,
                        "compare": {
                          "value": 100,
                          "percent": null
                        },
                        "current": {
                          "value": 42,
                          "percent": -58
                        },
                        "partial": null,
                        "isFuture": false,
                        "isDefault": true,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 9,
                        "compare": {
                          "value": 100,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 10,
                        "compare": {
                          "value": 94,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 11,
                        "compare": {
                          "value": 92,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      },
                      {
                        "cif": null,
                        "fob": null,
                        "colName": 12,
                        "compare": {
                          "value": 92,
                          "percent": null
                        },
                        "current": {
                          "value": null,
                          "percent": null
                        },
                        "partial": null,
                        "isFuture": true,
                        "isDefault": false,
                        "colGroupName": null,
                        "isPreliminary": false
                      }
                    ],
                    "columnType": "M"
                  }
                ],
                "pieGraphs": [
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 96,
                        "colName": 1,
                        "percent": 55,
                        "valueCompare": 117,
                        "percentCompare": 57
                      },
                      {
                        "title": "Specialties",
                        "value": 79,
                        "colName": 1,
                        "percent": 45,
                        "valueCompare": 90,
                        "percentCompare": 43
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 89,
                        "colName": 2,
                        "percent": 55,
                        "valueCompare": 116,
                        "percentCompare": 56
                      },
                      {
                        "title": "Specialties",
                        "value": 72,
                        "colName": 2,
                        "percent": 45,
                        "valueCompare": 90,
                        "percentCompare": 44
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 199,
                        "colName": 3,
                        "percent": 71,
                        "valueCompare": 117,
                        "percentCompare": 57
                      },
                      {
                        "title": "Specialties",
                        "value": 82,
                        "colName": 3,
                        "percent": 29,
                        "valueCompare": 89,
                        "percentCompare": 43
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 69,
                        "colName": 4,
                        "percent": 56,
                        "valueCompare": 115,
                        "percentCompare": 55
                      },
                      {
                        "title": "Specialties",
                        "value": 55,
                        "colName": 4,
                        "percent": 44,
                        "valueCompare": 94,
                        "percentCompare": 45
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 96,
                        "colName": 5,
                        "percent": 63,
                        "valueCompare": 114,
                        "percentCompare": 55
                      },
                      {
                        "title": "Specialties",
                        "value": 56,
                        "colName": 5,
                        "percent": 37,
                        "valueCompare": 95,
                        "percentCompare": 45
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 96,
                        "colName": 6,
                        "percent": 58,
                        "valueCompare": 115,
                        "percentCompare": 55
                      },
                      {
                        "title": "Specialties",
                        "value": 69,
                        "colName": 6,
                        "percent": 42,
                        "valueCompare": 93,
                        "percentCompare": 45
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 71,
                        "colName": 7,
                        "percent": 68,
                        "valueCompare": 135,
                        "percentCompare": 57
                      },
                      {
                        "title": "Specialties",
                        "value": 33,
                        "colName": 7,
                        "percent": 32,
                        "valueCompare": 101,
                        "percentCompare": 43
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 49,
                        "colName": 8,
                        "percent": 54,
                        "valueCompare": 136,
                        "percentCompare": 58
                      },
                      {
                        "title": "Specialties",
                        "value": 42,
                        "colName": 8,
                        "percent": 46,
                        "valueCompare": 100,
                        "percentCompare": 42
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 137,
                        "percentCompare": 58
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 9,
                        "percent": 0,
                        "valueCompare": 100,
                        "percentCompare": 42
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 117,
                        "percentCompare": 55
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 10,
                        "percent": 0,
                        "valueCompare": 94,
                        "percentCompare": 45
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 117,
                        "percentCompare": 56
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 11,
                        "percent": 0,
                        "valueCompare": 92,
                        "percentCompare": 44
                      }
                    ],
                    "isCompare": true
                  },
                  {
                    "data": [
                      {
                        "title": "Commodities",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 116,
                        "percentCompare": 56
                      },
                      {
                        "title": "Specialties",
                        "value": 0,
                        "colName": 12,
                        "percent": 0,
                        "valueCompare": 92,
                        "percentCompare": 44
                      }
                    ],
                    "isCompare": true
                  }
                ],
                "isMainGraph": true
              },
              "title": "BGT"
            }
          ]
        },
        "title": "EBITDA"
      }
    ],
    "type": "GraphMenu"
  }
}
